
if (window.matchMedia("(max-width: 768px)").matches) {

(function () {
  if (window.__CUSTOM_PDP_INIT__) return;
  window.__CUSTOM_PDP_INIT__ = true;


  (function injectCSS() {
    var rawCss = `
  #shopify-section-header {
    min-height: 101px;
}
  #shopify-section-header.header-fixed, 
  .shopify-section.header-fixed .cst-mob-header {
    width: 100%;
    height: auto;
}
  .shopify-section.header-fixed .cst-mob-header, 
  .shopify-section.header-fixed .cst-header-sec {
    top: 0 !important;
    position: absolute !important;
}
/*.CP_AS_PDP_01 #shopify-section-header.scrollback-fix, 
.CP_AS_PDP_01 #shopify-section-header.header-fixed.scrollback-fix, */
  .shopify-section.scrollback-fix .cst-mob-header,
  .shopify-section.header-fixed.scrollback-fix .cst-mob-header {
    position: fixed;
}



/* When added the show-fixed class */
 .show-fixed .product-form__for_floating h2.product-single__title, 
 .show-fixed .product-form__for_floating .product__price {
    display: block;
}
 .show-fixed .product-form__for_floating {
     position: fixed;
    top: 55px;
    background: #fff;
    width: 100%;
    left: 0;
    z-index: 999;
    padding: 15px 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: .6s;
    transform: translateY(20px);
    box-shadow: #0000003d 0 3px 8px;
    flex-wrap: wrap;
}
 .show-fixed .product-form__for_floating .size-link-box {
    display: none;
}
 .show-fixed .product-form__for_floating .prd-title {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    flex-wrap: wrap;
}
 .show-fixed .product-form__for_floating .prd-title h2.product-single__title {
    font-size: 20px;
    line-height: normal;
    width: auto;
    margin: 0;
}
 .show-fixed .product-form__for_floating .prd-title .product__price {
    width: auto;
    padding-left: 10px;
}
 .show-fixed .product-form__for_floating .product-form__for_floating-right {
    display: flex;
    justify-content: space-between;
    gap: 12px;
}
 .show-fixed .product-form__for_floating .product-form__controls-group {
    display: block;
}
 .show-fixed .product-form__for_floating .product-form__for_floating-right .product-form__controls-group~.product-form__controls-group--submit {
    margin-top: 0;
    min-width: 190px;
}
 .show-fixed .product-form__for_floating .product-form__for_floating-right .product-form__controls-group {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    width: auto;
    justify-content: end;
    position: relative;
}
 .show-fixed .product-form__for_floating .product-form__item--submit {
    flex: unset;
}
 .show-fixed .product-form__for_floating .product-form__for_floating-right .btn.product-form__cart-submit {
    border-radius: 50px!important;
}
 .show-fixed .product-form__for_floating .product-form__for_floating-right .product-form__input--quantity {
    max-width: 100%;
    padding: 0;
    text-align: center;
    border-radius: 24px;
    min-height: 40px;
}
 .show-fixed .product-form__for_floating .product-form__for_floating-right .product-form__controls-group {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    width: auto;
    justify-content: end;
    position: relative;
}
 .show-fixed .product-form__for_floating .product-form__for_floating-right .quantity-wrapper {
    position: relative;
    width: 100%;
}
 .show-fixed .product-form__for_floating .product-form__for_floating-right div#product-messages {
    display: none;
}
 .show-fixed .product-form__for_floating .product-form__for_floating-right .product-form__item {
    padding: 0;
    max-width: 90px;
    flex: 0;
    position: relative;
    margin-bottom: 4px;
}
 .show-fixed .product-form__for_floating .product-form__for_floating-left .product-size .size-box.mb-15 {
    border-right: 1px solid #000;
    margin-right: 6px;
}
 .show-fixed .product-form__for_floating .product-form__for_floating-left .product-size {
    position: relative;
    display: flex;
    align-items: center;
    column-gap: 10px;
}
 .show-fixed .product-form__for_floating .product-form__for_floating-left .size-each-pro.size-each {
    font-size: 12px;
    padding: 2px;
    min-width: 30px;
    margin: 0 2.5px !important;
    box-shadow: #0000000d 0 1px 2px;
}
 .show-fixed .product-form__for_floating .product-form__for_floating-left ul.product-sizes-system li {
    font-size: 12px;
    padding: 5px;
    box-shadow: #0000003d 0 3px 8px;
}
 .show-fixed .product-form__for_floating .product-form__for_floating-left .product-size .size-box.mb-15,
  .product-form__for_floating.active .product-form__for_floating-left .product-size .size-box.mb-15 {
    margin: 10px 0;
    padding: 0;
}
 .show-fixed .product-form__for_floating .sizes_no {
    display: flex;
    align-items: center;
}
 .show-fixed .product-form__for_floating .product-form__for_floating-left .product__price dl.price span.money {
    font-size: 15px;
}
 .show-fixed .product-form__for_floating .product-form__for_floating-right .product-form__item {
    padding: 12px 0 0;
    max-width: 90px;
    flex: 0;
    position: relative;
    margin-bottom: 0px;
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    row-gap: 5px;
}
 .show-fixed .product-form__for_floating .product-form__for_floating-right {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    align-items: flex-start;
}
 .show-fixed .product-form__for_floating .product-form__for_floating-right .quantity-wrapper .quantity-btn--minus {
    position: absolute;
    left: 5px;
    z-index: 1;
}
 .show-fixed .product-form__for_floating .product-form__for_floating-right .quantity-wrapper .quantity-btn.quantity-btn--plus {
    position: absolute;
    right: 5px;
}
 .show-fixed .product-form__for_floating .product-form__for_floating-right .product-form__item label {
    font-size: 12px;
    margin-bottom: 0;
    text-align: center;
}
 .show-fixed .product-form__for_floating .product-form__for_floating-right .product-form__controls-group .pdp-stock-alert-box {
    width: 100px;
    position: absolute;
    top: -7px;
}
 .show-fixed .product-form__for_floating .ultimate-badges {
    display: none;
}
 .show-fixed .custom-product-info .product-form__for_floating .btn.product-form__cart-submit {
    margin-top: 0px;
    font-size: 12px !important;
    margin-bottom: 0;
    font-weight: 400 !important;
    min-height: 40px!important;
}
 .show-fixed .product-form__for_floating .hidden {
  display: block !important;
}


/* Gives Back Section */
.pdp-givesback-section {
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    letter-spacing: 0.5px;
    text-align: center;
    padding: 20px 5px 28px 5px;
    background: #424242;
}
.pdp-givesback-section img {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
}
.pdp-givesback-section h2 {
    font-size: 32px;
    font-weight: normal !important;
    line-height: 118.75%;
    letter-spacing: 0;
    text-transform: none;
    margin: 5px 0 20px;
}
.pdp-givesback-section h4 {
    font-style: normal;
    font-weight: 400 !important;
	line-height: 150%;
	letter-spacing: 0.5px;
	margin: 0 0 21px;
}
.pdp-givesback-section ul {
    text-align: left;
    list-style: none !important;
    margin: 0 20px;
    padding: 17px 0 0;
    border-top: 1px solid #FFF;
}
.pdp-givesback-section ul > li {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-ms-flex-wrap: nowrap;
	    flex-wrap: nowrap;
	margin: 10px 0;
}
.pdp-givesback-section ul > li .icon {
    width: 19px;
    height: 18px;
    min-width: 19px;
    margin-right: 12px;
    -ms-flex-item-align: center;
        -ms-grid-row-align: center;
        align-self: center;
}
.pdp-givesback-section ul > li .icon svg {
    width: 100%;
    height: auto;
}
.pdp-givesback-section .btn-more {
	margin: 27px auto 0;
}



@media (min-width: 851px) {
	
	.about-these-shoes-section,
	.ant-sole-cst-container.pro-custom-sect .custom-add-to-cart-section,
	.pdp-givesback-section {
		display: none !important;
	}
	
}



@media (max-width: 850px) {
    /* When added the show-fixed class */
   .show-fixed .product-form__for_floating {
    transform: translateY(-15px);
}
   .show-fixed .product-form__for_floating .prd-title h2.product-single__title {
    font-size: 12px;
}
   .show-fixed .product-form__for_floating .price__vendor {
    display: none;
}
   .show-fixed .product-form__for_floating .price-item {
    font-size: 12px;
}
   .show-fixed .custom-product-info .product-form__for_floating .btn.product-form__cart-submit,
   .show-fixed .product-form__for_floating .product-form__for_floating-right .product-form__input--quantity {
    min-height: 35px!important;
}
   .show-fixed .product-form__for_floating .product-form__for_floating-right .product-form__item label {
    display: none;
}
    .show-fixed .product-form__for_floating {
    padding: 10px 16px;
}

/*   .mobile-main-pro-slide:not(.slick-initialized),
  .mobile-thumb-slide:not(.slick-initialized),
  .cp_instaslider:not(.slick-initialized),
  .must-have-images-wrap:not(.slick-initialized),
  .ant-sole-cst-container.pro-custom-sect .hm-fav-product-listing-main:not(.slick-initialized) {
    display:none !important;
} */
  .mobile-main-pro-slide:not(.slick-initialized) > * {
    display:none !important;
}
	
/**/
  .page-width {
  padding-left: 16px;
  padding-right: 16px;
}
	
  .mob_slick_img {
  max-height: 100vw;
}
  .product-template__container .mobile-image-section .slick-arrow {
    width: 35px;
    height: 35px;
    border-radius: 100%;
    border: 1px solid #EEE;
    background: #ffffff;
    z-index: 2;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    font-size: 0 !important;
    line-height: 0 !important;
}
  .product-template__container .mobile-image-section .slick-arrow:before { display:none!important; }
  .product-template__container .mobile-image-section .slick-arrow:after {
    content: "";
    display: block;
    width: 9px;
    height: 9px;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
    opacity: 0.7;
}
  .product-template__container .mobile-image-section .slick-arrow.slick-prev {
    left: 12px;
}
  .product-template__container .mobile-image-section .slick-arrow.slick-prev:after {
    border-left: 2px solid #000;
    border-bottom: 2px solid #000;
    margin-right: -2px;
}
  .product-template__container .mobile-image-section .slick-arrow.slick-next {
    right: 12px;
}
  .product-template__container .mobile-image-section .slick-arrow.slick-next:after {
    border-right: 2px solid #000;
    border-top: 2px solid #000;
    margin-left: -2px;
}
  .product-template__container .mobile-image-section .slick-dots {
  left: 0 !important;
  right: 0 !important;
}
  .mobile-main-pro-slide .slick-slide img {
    height: 390px !important;
    aspect-ratio: 1 / 1 !important;
    -o-object-fit: contain !important;
       object-fit: contain !important;
        background: #F7F7F7;
}

/**/
  footer.custom-footer {
    margin-top: 0;
    padding-top: 0;
    padding-bottom: 100px;
    border-top: 8px solid #AB3F22;
}
  .ansl-cst-product-pg-sec.page-width {
	overflow: hidden;
}

/**/
  .shopify-section.header-fixed .ext-top-bar {
	position: absolute;
}

/* Mobile Thumbnail Slides */
  .product-single__media-group, 
  .product-single__media--has-thumbnails {
	margin-bottom: 9px;
}
  .mobile-image-section {
  position: relative;
  overflow: hidden;
}
  .mobile-image-section .mobile-thumb-slide {
  padding: 9px 0 0 16px;
  margin: 0;
}
  .mobile-image-section .mobile-thumb-slide .slick-slide {
	width: 80px !important;
	height: 80px !important;
	position: relative;
	overflow: hidden;
	border-radius: 3px;
	border: 1px solid transparent;
	padding: 5px;
	margin-right: 8px;
}
  .mobile-image-section .mobile-thumb-slide .slick-slide img {
	  border-radius: 3px;
	  width: 100% !important;
	  height: 100% !important;
	  max-width: 100% !important;
	  max-height: 100% !important;
	  min-width: 100% !important;
	  min-height: 100% !important;
	  -o-object-fit: cover !important;
	     object-fit: cover !important;
	  -o-object-position: center center;
	     object-position: center center;
}
  .mobile-image-section .mobile-thumb-slide .slick-slide.slick-current.slick-active {
	border-color: #AB3F22;
}


  .product-single__meta > .price-title > .jdgm-widget {
  -webkit-box-ordinal-group: 2;
      -ms-flex-order: 1;
          order: 1;
  padding: 10px 0;
  margin: 0;
  width: 100%;
}
  .product-single__meta > .price-title .jdgm-prev-badge__stars {
    margin-right: 2px;
}
  .product-single__meta > .price-title .jdgm-prev-badge__text {
    color: #282828;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    letter-spacing: 0.5px;
    text-decoration: underline;
}
  .product-single__meta > .price-title > .product-single__title {
    -webkit-box-ordinal-group: 3;
    -ms-flex-order: 2;
    order: 2;
    margin: 0;
    padding: 8.5px 0;
    color: #282828;
    font-family: Roboto;
    font-size: 18px;
    font-style: normal;
    font-weight: 500 !important;
    line-height: 105.882%;
}
  .product-single__meta > .price-title > .product__price {
  -webkit-box-ordinal-group: 4;
      -ms-flex-order: 3;
          order: 3;
}
  .product-single__meta > .price-title .price__regular {
    color: #282828;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 210%;
    letter-spacing: 0.5px;
}
  .product-single__meta > .price-title .price-item--regular {
    color: inherit;
    font-family: inherit;
    font-size: inherit;
    font-style: inherit;
    font-weight: 600;
    line-height: inherit;
    letter-spacing: inherit;
}
  .product-single__meta > .price-title .priceLabel {
    color: inherit;
    font-family: inherit;
    font-size: inherit;
    font-style: inherit;
    font-weight: inherit;
    line-height: inherit;
    letter-spacing: inherit;
    text-transform: lowercase;
    margin-left: 3px;
}
  .product-single__meta > .price-title .price__pricing-group, 
  .product-single__meta > .price-title .price__pricing-group > *, 
  .product-single__meta > .price-title .price__pricing-group > * > * {
    width: 100%;
    min-width: 100%;
}
  .custom-product-info .review-offer {
    display: none !important;
}
  .custom-product-info form.product-form {
    padding: 0;
    margin: 0;
    border-top: 0 none;
}
/* Colors */
  .custom-product-info .product-colors {
    margin-top: 9px;
    margin-bottom: 12px;
}
  .custom-product-info .product-colors .label {
    color: #282828;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 166.66%;
    letter-spacing: 0.5px;
    margin: 0 0 6px;
}
  .custom-product-info .product-colors .label + h4,
  .custom-product-info .product-colors ul.swatch li > *:not(a, img), 
  .custom-product-info form.product-form .product-short-info,
  .review-acord.f-acord,
  .more-faqs-text.f-acord,
  .product-form__for_floating.active .product__price,
 .show-fixed .product-form__for_floating .product__price {
	display: none !important;
}
  .custom-product-info .product-colors ul.swatch {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    gap: 10px 14px;
}
  .custom-product-info .product-colors ul.swatch li {
    width: 32px !important;
    height: 32px !important;
    padding: 0 !important;
    margin: 0 !important;
    border: 1px solid transparent;
    border-radius: 100%;
    position: relative;
    overflow: hidden;
}
  .custom-product-info .product-colors ul.swatch li > a,
  .custom-product-info .product-colors ul.swatch li img {
    display: block;
    width: 100%;
    height: 100%;
}
  .custom-product-info .product-colors ul.swatch li img {
    border: 0 none !important;
    border-radius: 0;
}
  .custom-product-info .product-colors ul.swatch li.active {
    border-color: #000000;
}
  .custom-product-info .product-colors ul.swatch + h4 {
    margin-top: 7px !important;
    font-size: 10px !important;
}
/* Size */
  .product-form__controls-group.cstm-quantity .product-form__item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: nowrap;
        flex-wrap: nowrap;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    gap: 20px 30px;
    margin: 0 0 11px;
}
  .product-form__controls-group.cstm-quantity .product-form__item label {
    color: #282828;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    letter-spacing: 0.5px;
    margin: 0;
    padding: 0;
}
  .product-form__controls-group.cstm-quantity .quantity-wrapper {
    width: 100%;
    max-width: 155px;
}
  .product-form__controls-group.cstm-quantity .quantity-wrapper .product-form__input--quantity {
    color: #282828;
    font-family: Roboto;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%;
    letter-spacing: 0.5px;
    padding: 9.5px 15px;
}
  .product-form__controls-group.cstm-quantity .quantity-wrapper button.quantity-btn {
    color: #282828;
    font-family: Roboto;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 1;
    letter-spacing: 0.5px;
    background: #F7F7F7;
    width: 37px !important;
    height: 37px !important;
}
/* Sizes System */
  .custom-product-info .product-sizes-system li {
    color: #282828;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 1;
    letter-spacing: 0.5px;
    padding: 7px 6px;
    border-radius: 3px;
    border: 1px solid #D0D0D0;
}
  .custom-product-info .product-sizes-system li.active,
  .custom-product-info .product-sizes-system li:hover {
    color: #FFF !important;
    background: #282828 !important;
    border-color: #282828 !important;
}
  .size-link-box > ul > li:nth-child(1) {
    margin-right: 20px;
}
  .size-link-box > ul > li > a {
    color: #282828;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    letter-spacing: 0.5px;
    text-decoration: underline;
}
  .custom-product-info .size-each {
    color: #282828;
    text-align: center;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    letter-spacing: 0.5px;
    padding: 10px;
    margin: 0;
    min-width: 50px;
    background: transparent;
    background-color: transparent;
    border: 1px solid #D0D0D0;
    border-radius: 6px;
    opacity: 1 !important;
}
  .custom-product-info .size-each.disabled {
    color: #CFCFCF;
    opacity: 1 !important;
    pointer-events: none;
    background: #f3f3f3 !important;
    background-color: #f3f3f3 !important;
}
  .custom-product-info .size-each.disabled:before {
    top: 50%;
    left: -18%;
    width: 130%;
    height: 1px;
    -ms-transform: rotate(-45deg);
    transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -webkit-transform: rotate(145deg);
    margin-left: 0;
    background: #CFCFCF;
    background-color: #CFCFCF;
}
  .custom-product-info .product-form__for_floating.active .size-each:not(.active),
  .custom-product-info .product-form__for_floating.active .size-each.disabled,
 .show-fixed .product-form__for_floating .size-each:not(.active),
 .show-fixed .product-form__for_floating .size-each.disabled {
    opacity: 1 !important;
}
  .custom-product-info .size-each.active {
    color: #FFF;
    background: #282828;
    border-color: #282828;
}
  .custom-product-info .product-size {
    position: relative;
    overflow: hidden;
    margin-right: -16px;
}
  #threshold_message_alert:not([style*="display:none"]) {
    display: inline-block;
    vertical-align: top;
    color: #ffffff !important;
    background: #a70808 !important;
    padding: 2px 10px;
    border-radius: 25px;
    margin: 0 0 5px;
}
  .custom-product-info .size-box {
    margin-bottom: 17px;
    padding-right: 16px;
}
  .custom-product-info .sizes_no {
    display: flex;
    flex-wrap: nowrap;
    gap: 10px 9px;
    justify-content: flex-start;
    padding: 0;
    margin: 0;
    overflow-x: auto !important;
    overflow-y: hidden !important;
    scrollbar-width: none;
    padding-right: 20px;
}
  .product-form__controls-group ~ .product-form__controls-group--submit {
    margin-top: 16px;
}
  .custom-product-info .btn.product-form__cart-submit {
    color: #FFF !important;
    text-align: center;
    font-family: Roboto;
    font-size: 16px !important;
    font-style: normal;
    font-weight: 400 !important;
    line-height: 1 !important;
    letter-spacing: 1px !important;
    text-transform: uppercase !important;
    border-radius: 35px !important;
    background: #AB3F22 !important;
    background-color: #AB3F22 !important;
    padding: 20px 30px !important;
    min-height: 50px !important;
    margin: 0 !important;
}
  .custom-product-info #shipp_accordion.ui-accordion .ui-accordion-header {
    color: #282828;
    font-family: Roboto;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
}
  .custom-product-info #shipp_accordion.ui-accordion .ui-accordion-header:first-of-type {
    border-top: 0 none !important;
}
  .custom-product-info #shipp_accordion.ui-accordion .ui-accordion-header {
    color: #282828;
    font-family: Roboto;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 144.444%;
    padding: 14px 30px 14px 0 !important;
    border-top-color: #F2F2F2 !important;
}
  .custom-product-info #shipp_accordion.ui-accordion .ui-accordion-header .ui-accordion-header-icon {
    top: 17px;
    right: 7px;
    margin-top: 0;
}
  .custom-product-info #shipp_accordion.ui-accordion .ui-accordion-header > span:not([class]) {
    width: 25px;
    height: 25px;
    min-width: 25px;
    min-height: 25px;
    margin-right: 13px;
}
  .custom-product-info #shipp_accordion.ui-accordion .ui-accordion-content {
    color: #282828;
    font-family: 'Roboto', sans-serif;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
}
  .custom-product-info #shipp_accordion.ui-accordion .ui-accordion-content .bs-pdp-careguide-txt,
  .custom-product-info #shipp_accordion.ui-accordion .ui-accordion-content p {
    font-family: inherit;
    font-size: inherit;
    font-style: inherit;
    font-weight: inherit;
    line-height: inherit;
}
  .custom-product-info #shipp_accordion.ui-accordion .ui-accordion-content .bs-pdp-careguide-title,
  .custom-product-info #shipp_accordion.ui-accordion .ui-accordion-content .bs-pdp-careguide-sub-title {
    font-family: inherit;
}
/* FIX - Add to cart */
  .product-form__for_floating.active,
 .show-fixed .product-form__for_floating {
    top: auto !important;
    bottom: 0 !important;
    -webkit-transform: none;
        -ms-transform: none;
            transform: none;
    -webkit-box-shadow: 0 1px 13.4px 1px #E4E4E4;
            box-shadow: 0 1px 13.4px 1px #E4E4E4;
            z-index: 999;
}
  .product-form__for_floating.active .product-form__item.top-float,
  .product-form__for_floating.active .product-form__item,
 .show-fixed .product-form__for_floating .product-form__item.top-float,
 .show-fixed .product-form__for_floating .product-form__item {
    margin: 0 !important;
    padding: 0 !important;
}
  .product-form__for_floating.active .product-form__item .btn.product-form__cart-submit,
 .show-fixed .product-form__for_floating .product-form__item .btn.product-form__cart-submit {
    margin: 0 !important;
    padding: 14px 30px !important;
    font-size: 12px !important;
    font-weight: 400 !important;
    min-height: auto !important;
}
  .product-form__for_floating.active .product-single__title,
 .show-fixed .product-form__for_floating .product-single__title {
    color: #000;
    font-family: Roboto;
    font-size: 15px !important;
    font-style: normal !important;
    font-weight: 400 !important;
    line-height: 1.5 !important;
    letter-spacing: 0.5px !important;
}
  .custom-product-info .sizeLabel {
    display: none !important;
}


 .show-fixed .custom-product-info .product-form__for_floating + * + .notify-wrapper.spo-container, 
  .custom-product-info .product-form__for_floating.active + * + .notify-wrapper.spo-container {
    opacity: 0 !important;
    min-height: 172px;
}
/*
  .custom-product-info .product-form__for_floating:not(.active),
 :not(.show-fixed) .custom-product-info .product-form__for_floating {
    min-height: 290px;
}
  .custom-product-info .product-form__for_floating.active .sizeLabel {
    color: #222421;
    text-align: center;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 192.857%;
    letter-spacing: 0.5px;
    display: block !important;
    padding: 4px 42px 4px 17px;
    border: 1px solid #EEE;
    border-radius: 28px;
    position: relative;
    overflow: hidden;
}
  .custom-product-info .product-form__for_floating.active .sizeLabel:after {
    content: "";
    width: 12px;
    height: 7px;
    position: absolute;
    inset: auto;
    top: 50%;
    left: 69%;
    -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
            transform: translateY(-50%);
    background-image: url("data:image/svg+xml,%3Csvg width='13' height='8' viewBox='0 0 13 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.6695 0.281986C13.0435 0.657968 13.0435 1.26754 12.6695 1.64352L7.15288 7.18838C6.97325 7.36893 6.72904 7.47095 6.475 7.47095C6.22097 7.47095 5.97734 7.36952 5.79771 7.18897L0.280545 1.64352C-0.0935151 1.26754 -0.0935151 0.657968 0.280545 0.281986C0.654604 -0.0939954 1.26107 -0.0939954 1.63513 0.281986L6.475 5.14667L11.3149 0.281986C11.6889 -0.0939954 12.2954 -0.0939954 12.6695 0.281986Z' fill='%23222421'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 12px 7px;
}
  .custom-product-info .product-form__for_floating.active .sizeLabel:before {
    content: "";
    position: absolute;
    inset: auto;
    bottom: 90%;
    left: -150%;
    width: 230px;
    height: 200px;
    z-index: 1;
}
*/
  .custom-product-info .product-form__for_floating {
    min-height: auto;
}
  .custom-product-info .product-form__for_floating.active,
 .show-fixed .custom-product-info .product-form__for_floating {
    min-height: auto;
}
  .custom-product-info .product-form__for_floating.active .sizeLabel,
 .show-fixed .custom-product-info .product-form__for_floating .sizeLabel {
    color: #222421;
    text-align: center;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 180%;
    letter-spacing: 0.5px;
    display: block !important;
    padding: 4px 10px;
    border: 1px solid #EEE;
    border-radius: 28px;
    min-width: 70px;
}
/*   .custom-product-info .product-form__for_floating.active .sizeLabel:before {
    content: "";
    width: 230px;
    height: 200px;
    z-index: 1;
    position: fixed;
    inset: auto;
    margin-top: -50%;
    margin-left: -37%;
} */
  .custom-product-info .product-form__for_floating.active .sizeLabel:after,
 .show-fixed .product-form__for_floating .sizeLabel:after {
    content: "";
    width: 9px;
    height: 6px;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    background-image: url("data:image/svg+xml,%3Csvg width='13' height='8' viewBox='0 0 13 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.6695 0.281986C13.0435 0.657968 13.0435 1.26754 12.6695 1.64352L7.15288 7.18838C6.97325 7.36893 6.72904 7.47095 6.475 7.47095C6.22097 7.47095 5.97734 7.36952 5.79771 7.18897L0.280545 1.64352C-0.0935151 1.26754 -0.0935151 0.657968 0.280545 0.281986C0.654604 -0.0939954 1.26107 -0.0939954 1.63513 0.281986L6.475 5.14667L11.3149 0.281986C11.6889 -0.0939954 12.2954 -0.0939954 12.6695 0.281986Z' fill='%23222421'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    position: static;
    display: inline-block;
    vertical-align: middle;
    margin-top: 6px;
    margin-left: 6px;
}
/*   .custom-product-info .product-form__for_floating.active .sizes_no {
		display: none;
    position: absolute;
    inset: auto;
    bottom: 125%;
    left: 50%;
    z-index: 9;
    -webkit-transform: translateX(-50%);
        -ms-transform: translateX(-50%);
            transform: translateX(-50%);
    background: #ffffff;
    padding: 10px 10px;
    width: 200px;
    border-radius: 20px;
    -webkit-box-shadow: 0px 2px 10px #cccccc;
            box-shadow: 0px 2px 10px #cccccc;
} */
  .custom-product-info .product-form__for_floating.active .size-each,
 .show-fixed .product-form__for_floating .size-each {
    font-size: 14px !important;
    line-height: 150%;
    padding: 6px 6px !important;
    min-width: 25px;
    box-shadow: none !important;
}
  .custom-product-info .product-form__for_floating.active .sizes_no,
 .show-fixed .product-form__for_floating .sizes_no {
    display: none;
    z-index: 99;
    -webkit-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
    background: #ffffff;
    padding: 14px 10px;
    border-radius: 20px;
    -webkit-box-shadow: 0px 2px 10px #cccccc;
    box-shadow: 0px 2px 10px #cccccc;
    position: fixed;
    inset: auto;
    margin: -32% 0 0;
    width: 95%;
    text-align: center;
    vertical-align: top;
}
/*  .custom-product-info .product-form__for_floating.active .sizeLabel:focus + .sizes_no,
  .custom-product-info .product-form__for_floating.active .sizeLabel:active + .sizes_no,
  .custom-product-info .product-form__for_floating.active .sizeLabel:hover + .sizes_no,*/
  .custom-product-info .product-form__for_floating.active .sizes_no.show,
 .show-fixed .product-form__for_floating .sizes_no.show {
	display: block !important;
}
  .product-form__for_floating.active .product-form__for_floating-right .product-form__controls-group.cstm-quantity,
 .show-fixed .product-form__for_floating .product-form__for_floating-right .product-form__controls-group.cstm-quantity {
    display: none !important;
}
  .product-form__for_floating.active > *,
 .show-fixed .product-form__for_floating > * {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 100% !important;
}
  .product-form__for_floating.active .product-form__for_floating-left,
 .show-fixed .product-form__for_floating .product-form__for_floating-left {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    gap: 20px 20px;
}
  .product-form__for_floating.active .prd-title, 
  .product-form__for_floating.active .prd-size,
 .show-fixed .product-form__for_floating .prd-title,
 .show-fixed .product-form__for_floating .prd-size {
    width: 50%;
}
  .product-form__for_floating.active .prd-title,
 .show-fixed .product-form__for_floating .prd-title { margin-bottom:0; }
  .product-form__for_floating.active .product-form__for_floating-right .product-form__controls-group,
  .product-form__for_floating.active .design-pre-order-template-wrapper.hover-visible.true-style, 
  .product-form__for_floating.active .spurit-po-wrapper,
  .product-form__for_floating.active .design-pre-order-template-wrapper, 
  .product-form__for_floating.active .design-pre-order-template-wrapper button,
 .show-fixed .product-form__for_floating .product-form__for_floating-right .product-form__controls-group,
 .show-fixed .product-form__for_floating .design-pre-order-template-wrapper.hover-visible.true-style,
 .show-fixed .product-form__for_floating .spurit-po-wrapper,
 .show-fixed .product-form__for_floating .design-pre-order-template-wrapper,
 .show-fixed .product-form__for_floating .design-pre-order-template-wrapper button {
    width: 100% !important;
}
  .product-form__for_floating.active > div + div,
 .show-fixed .product-form__for_floating > div + div {
    margin-top: 15px;
}
  .product-form__for_floating.active .product-form__for_floating-left ul.product-sizes-system li,
 .show-fixed .product-form__for_floating .product-form__for_floating-left ul.product-sizes-system li {
    font-size: 14px !important;
    margin-right: 10px;
}
 .show-fixed .product-form__for_floating .product-form__for_floating-left .product-size,
  .product-form__for_floating.active .product-form__for_floating-left .product-size {
    margin: -10px 0;
}


/* Look Book Section */
  .image-grid-section {
    display: none;
}


/* Sin Pro Fea */
  .sin-pro-fea-pro-sec {
    padding: 0;
}
  .sin-pro-fea-pro-left,
  .sin-pro-fea-pro-cont > h3:first-child,
  .sin-pro-fea-pro-cont ul li > p:last-child {
    display: none !important;
}
  .sin-pro-fea-pro-cont {
    padding: 0;
    width: 100%;
    max-width: 100%;
}
  .sin-pro-fea-pro-cont ul {
    width: auto;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    padding: 0;
    margin: 0 -10px;
}
  .sin-pro-fea-pro-cont ul li {
    width: 25%;
    clear: none !important;
    padding: 5px 10px 0;
}
  .sin-pro-fea-pro-cont ul li > div {
    margin-bottom: 7px;
}
  .sin-pro-fea-pro-cont h4 {
    color: #282828;
    text-align: center;
    font-family: Roboto;
    font-size: 10px;
    font-style: normal;
    font-weight: 400 !important;
    line-height: 160%;
    letter-spacing: 0.5px;
    margin: 0;
}
  .sin-pro-fea-pro-cont p {
    color: #231F20;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 128.571%;
    letter-spacing: 0.5px;
    text-align: left;
    min-height: auto;
    margin: 21px 0 0;
}
  .sin-pro-fea-pro-cont p strong {
	font-weight: normal;
}
  .sin-pro-fea-pro-cont p span {
	text-decoration: underline;
}
  .sin-pro-fea-pro-cont p:last-child {
	margin-bottom: 0;
	padding-bottom: 0;
}



/* What about these shoes */
  .about-these-shoes-section {
	position: relative;
	overflow: hidden;
	background: -webkit-gradient(linear, left top, left bottom, from(#EDF0EF), color-stop(130.65%, #E2E2E2));
	background: -o-linear-gradient(top, #EDF0EF 0%, #E2E2E2 130.65%);
	background: linear-gradient(180deg, #EDF0EF 0%, #E2E2E2 130.65%);
  margin: 25px 0 3px;
}
  .about-these-shoes-section .wrap-container {
	position: relative;
	padding: 16px 12px 27px;
}
  .about-these-shoes-section .wrap-container:before,
  .about-these-shoes-section .wrap-container:after {
  content: "";
  width: 100%;
  height: 249px;
  position: absolute;
  inset: 0;
  bottom: auto;
  background: -webkit-gradient(linear, left top, left bottom, from(#DFE0E0), to(rgba(223, 224, 224, 0.00)));
  background: -o-linear-gradient(180deg, #DFE0E0 0%, rgba(223, 224, 224, 50%) 75%, rgba(223, 224, 224, 0.00) 100%);
  background: linear-gradient(180deg, #DFE0E0 0%, rgba(223, 224, 224, 50%) 75%, rgba(223, 224, 224, 0.00) 100%);
  z-index: 1;
}

  .about-these-shoes-section .wrap-container:after {
    transform: rotate(180deg);
    top: auto;
    bottom: 0;
    height: 50%;
    /*
    background: -webkit-gradient(linear-gradient(180deg, #E2E2E2 0%, #EDF0EF 58%, rgba(226, 226, 226, 0.0) 100%));
    background: -o-linear-gradient(180deg, #E2E2E2 0%, #EDF0EF 58%, rgba(226, 226, 226, 0.0) 100%);
    background: linear-gradient(180deg, #E2E2E2 0%, #EDF0EF 58%, rgba(226, 226, 226, 0.0) 100%);
    */
}

  .about-these-shoes-section .wrap-container > *:not(img) {
    position: relative;
    z-index: 2;
}
  .abouttheseshoes-img {
    position: absolute;
    inset: 0;
    bottom: auto;
    z-index: 0;
    width: 100% !important;
    max-width: 100% !important;
    object-fit: cover;
    object-position: center top;
    height: 100% !important;
}
  .abouttheseshoes-hr {
	padding: 0;
	margin: 0 0 15px;
	border: 0 none;
	width: 70%;
	max-width: 254px;
	height: 1px;
	background: #AB3F22;
}
  .about-these-shoes-section h2 {
    color: #282828;
	font-weight: normal !important;
	letter-spacing: 0.5px;
	line-height: 118.75%;
  text-transform: none;
  margin: 0 0 10px;
}
  .about-these-shoes-section h4 {
    color: #282828;
    font-family: Roboto;
    font-size: 18px;
    font-style: normal;
    font-weight: 400 !important;
    line-height: 150%;
    letter-spacing: 0.5px;
  margin: 0 0 25px;
}
  .about-these-shoes-section p {
	color: #231F20;
font-size: 18px;
font-style: normal;
line-height: 150%;
letter-spacing: 0.5px;
}
/*  .abouttheseshoes-headings + p { padding-top:230px; }*/
  .abouttheseshoes-headings + p { padding-top:170px; }



/* Judge Me Review Section */
  .jdgm-carousel-wrapper {
    padding: 14px 0;
}
  .jdgm-carousel-wrapper .jdgm-carousel-title,
  .jdgm-carousel-wrapper .jdgm-all-reviews-rating-wrapper {
	text-align: center !important;
}
  .jdgm-carousel-wrapper .jdgm-carousel-label {
    color: #282828;
    text-align: center;
    font-family: Roboto;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    letter-spacing: 0.5px;
    margin: 0;
    padding: 0;
}
  .jdgm-carousel-title-and-link {
    padding: 0 12px;
    margin: 0;
}
  .jdgm-carousel-wrapper .jdgm-carousel-title {
    color: #282828;
    font-family: Roboto;
    font-size: 28px;
    font-style: normal;
    font-weight: 400 !important;
    line-height: 118.75%;
    letter-spacing: 0;
    text-transform: none;
    padding: 0;
    margin: 0 0 12px;
}
  .jdgm-carousel-number-of-reviews[data-number-of-reviews] {
    color: #282828;
    font-family: Roboto;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    letter-spacing: 0.5px;
    margin: 0;
}
  .jdgm-widget.jdgm-widget {
    position: relative;
    overflow: hidden;
    margin: 19px 0 8px;
}
  .jdgm-carousel--card-theme .jdgm-carousel-item {
    padding: 0 33px;
}
  .jdgm-carousel--card-theme .jdgm-carousel-item__inner-wrapper {
    border-radius: 6px;
    background: #F8F8F8;
    -webkit-box-shadow: none;
            box-shadow: none;
    padding: 15px 18px;
}
  .jdgm-carousel--card-theme .jdgm-carousel-item__review-rating {
    margin-bottom: 9px;
}
  .jdgm-carousel-item__review-title.jdgm-line-clamp {
    color: #282828;
    font-family: Roboto;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
    margin: 0 0 8px;
}
  .jdgm-carousel-item__review-body, 
  .jdgm-carousel-item__review-body p {
    color: #282828;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
}
  .jdgm-carousel--card-theme .jdgm-carousel-item__review {
    min-width: 123px;
    height: auto !important;
}
  .jdgm-carousel--card-theme .jdgm-carousel-item__reviewer-name-wrapper {
    margin: 8px 0 0;
}
  .jdgm-carousel--card-theme .jdgm-carousel-item__reviewer-name {
    color: #282828;
    font-family: Roboto;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
    opacity: 1;
    margin: 0;
    padding: 0;
}
  .jdgm-carousel--card-theme .jdgm-carousel-item__product {
    display: none !important;
}
  .jdgm-carousel-item__timestamp.jdgm-ellipsis {
    opacity: 1;
    color: #282828;
    font-family: Roboto;
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
}
  .jdgm-carousel__arrows {
    margin: 0;
}
.jdgm-carousel__left-arrow, .jdgm-carousel__right-arrow {
        width: 40px !important;
        height: 40px !important;
        border: 0 none;
        margin: 0;
        -webkit-transform: none;
        -ms-transform: none;
        transform: none !important;
        border-radius: 50px;
        background: #EDEDED;
        line-height: 1;
        display: -webkit-box !important;
        display: -ms-flexbox !important;
        display: flex !important;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        text-align: center;
        position: absolute;
        inset: auto;
        top: 50%;
        -webkit-transform: translateY(-50%) !important;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%) !important;
        opacity: 1 !important;
    }
  .jdgm-carousel__left-arrow:after, 
  .jdgm-carousel__right-arrow:after {
	content: "";
  display: block;
  width: 11px;
  height: 11px;
  -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
          transform: rotate(45deg);
}
  .jdgm-carousel__left-arrow { left:2px; }
  .jdgm-carousel__left-arrow:after {
    border-left: 2px solid #000;
    border-bottom: 2px solid #000;
    margin-right: 0;
        margin-bottom: 2px;
} 
  .jdgm-carousel__right-arrow { right:1px; }
  .jdgm-carousel__right-arrow:after {
    border-right: 2px solid #000;
    border-top: 2px solid #000;
    margin-left: -2px;
}



/* Brand Wrapper */
  .brands-section .brands-wrapper {
    margin: 0;
    padding: 20px 0;
    background: transparent;
}
  .brands-section .brands-title p {
    color: #282828;
    font-size: 32px !important;
    line-height: 118.75%;
}


/* Instagram Picture */
  .ant-bot-insta-sec-main .slick-list .slick-list, 
  .ant-bot-insta-sec-main .slick-track .slick-track {
    padding-left: 0 !important;
    padding-right: 0 !important;
}
  .ant-bot-insta-sec-main .slick-track {
    padding: 40px 0;
}
  .instapic-with-reviewtext.ant-bot-insta-sec-main .hm-tp-fav-title-sec,
  .instapic-with-reviewtext.ant-bot-insta-section .instaslider .instabox a > span {
	display: none;
}
  .ant-bot-insta-section .instaslider .instabox a {
    position: relative;
    overflow: hidden;
    display: block;
}
  .ant-bot-insta-section .instaslider .instabox a:before {
    content: "";
    width: 100%;
    height: 146px;
    background: -webkit-gradient(linear, left top, left bottom, from(rgba(18, 18, 18, 0.80)), to(rgba(18, 18, 18, 0.00)));
    background: -o-linear-gradient(top, rgba(18, 18, 18, 0.80) 0%, rgba(18, 18, 18, 0.00) 100%);
    background: linear-gradient(180deg, rgba(18, 18, 18, 0.80) 0%, rgba(18, 18, 18, 0.00) 100%);
    position: absolute;
    inset: 0;
    bottom: auto;
}
  .ant-bot-insta-section .instaslider .slick-slide .instabox, 
  .ant-bot-insta-section .instaslider .slick-slide.instabox > a {
    -webkit-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
    transition: all 0.5s ease-in-out;
    -webkit-transform: scale(1);
        -ms-transform: scale(1);
            transform: scale(1);
}
  .ant-bot-insta-section .instaslider .slick-current.slick-active .instabox, 
  .ant-bot-insta-section .instaslider .slick-current.slick-active.instabox > a {
    -webkit-transform: scale(1.1);
        -ms-transform: scale(1.1);
            transform: scale(1.1);
}



/* Video Reviews */
  .cstm-testimonial.video-reviews {
    padding: 0 0 15px;
    margin: 0;
}
  .cstm-testimonial.video-reviews .tabs-stage {
    padding: 0;
    margin: 0;
    inset: 0;
}
  .cstm-testimonial.video-reviews .tab-heading {
    font-size: 32px;
    font-weight: 400;
    line-height: 150%;
    text-transform: capitalize;
    padding: 0;
    margin: 0;
}
  .vid-wrapper--slider .slick-track {
	padding: 45px 0 30px;
}
  .vid-wrapper--slider .slick-slide {
    margin: 0 11px;
}
  .vid-wrapper--slider .vid.item--cst {
	position: relative;
	overflow: hidden;
    -webkit-transform: scale(1);
        -ms-transform: scale(1);
            transform: scale(1);
    -webkit-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
    transition: all 0.5s ease-in-out;
}
  .vid-wrapper--slider .vid.item--cst:after {
	content: "";
	position: absolute;
	inset: 0;
	z-index: 0;
	width: 100%;
	height: 100%;
	background: -webkit-gradient(linear, left top, left bottom, color-stop(21.96%, rgba(18, 18, 18, 0.00)), to(rgba(18, 18, 18, 0.80)));
	background: -o-linear-gradient(top, rgba(18, 18, 18, 0.00) 21.96%, rgba(18, 18, 18, 0.80) 100%);
	background: linear-gradient(180deg, rgba(18, 18, 18, 0.00) 21.96%, rgba(18, 18, 18, 0.80) 100%);
}
  .vid-wrapper--slider .vid.item--cst img.play-btn {
	z-index: 1;
}
  .vid-wrapper--slider .slick-current.slick-active .vid.item--cst {
    -webkit-transform: scale(1.1);
        -ms-transform: scale(1.1);
            transform: scale(1.1);
}
  .vid-wrapper--slider .videoreview-content {
	position: absolute;
	inset: 0;
	top: auto;
	z-index: 1;
  padding: 22px;
  color: #E3E3E3;
	font-family: Roboto;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: 155%;
}
  .vid-wrapper--slider .videoreview-content .videoreview-stars {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  gap: 5px 4px;
  margin: 0 0 5px;
}
  .vid-wrapper--slider .videoreview-content p {
  color: inherit;
  font-size: inherit;
  line-height: inherit;
  margin: 0;
  padding: 0;
}
  .vid-wrapper--slider .videoreview-content p.videoreview-title {
	color: #FFF;
	font-size: 125%;
	font-weight: 600;
	line-height: 140%;
	margin: 0 0 1px;
}
  .vid-wrapper--slider ul.slick-dots {
    font-size: 0;
    line-height: 0;
}
  .vid-wrapper--slider .slick-dots li button, 
  .vid-wrapper--slider .slick-dots li a {
	font-size: 0;
	line-height: 0;
}
  .vid-wrapper--slider .slick-dots li button:before, 
  .vid-wrapper--slider .slick-dots li a:before {
	display: none;
}



/* Sin Pro Text Image Slide Main */
/*  .sin-pro-text-img-slide-main { display:none!important; }*/
  .sin-pro-text-img-slide-main {
    padding: 20px 25px 8px;
    margin: 0;
}
  .sin-pro-text-img-slide-main .mobile-custom-grid-sect-cont {
    padding: 0 0 10px;
}
  .sin-pro-text-img-slide-main .mobile-custom-grid-sect-cont h3 {
    color: #282828;
    text-align: center;
    font-family: Roboto;
    font-size: 32px;
    font-style: normal;
    font-weight: 400;
    line-height: 118.75%;
    margin: 0 0 9px;
}
  .sin-pro-text-img-slide-main .mobile-custom-grid-sect-cont p {
    color: #282828;
    font-family: Roboto;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    text-align: center;
    margin: 0;
    padding: 0;
}
  .sin-pro-text-img-slide-main .mobile-custom-grid-sect-inn .img-full-width,
  .sin-pro-text-img-slide-main .mobile-custom-grid-sect-inn .image-half-width {
	display: none !important;
}
  .sin-pro-text-img-slide-main .must-have-images-wrap img {
    border-radius: 20px;
}
  .sin-pro-text-img-slide-main .must-have-images-wrap .slick-arrow {
    width: 35px;
    height: 35px;
    border-radius: 100%;
    border: 1px solid #EEE;
    background: #ffffff;
    z-index: 1;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
}
  .sin-pro-text-img-slide-main .must-have-images-wrap .slick-arrow:after {
	content: "";
  display: block;
  width: 9px;
  height: 9px;
  -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
          transform: rotate(45deg);
  opacity: 0.7;
}
  .sin-pro-text-img-slide-main .must-have-images-wrap .slick-arrow.slick-prev { left:-14px; }
  .sin-pro-text-img-slide-main .must-have-images-wrap .slick-arrow.slick-prev:after {
    border-left: 2px solid #000;
    border-bottom: 2px solid #000;
    margin-right: -2px;
} 
  .sin-pro-text-img-slide-main .must-have-images-wrap .slick-arrow.slick-next { right:-15px; }
  .sin-pro-text-img-slide-main .must-have-images-wrap .slick-arrow.slick-next:after {
    border-right: 2px solid #000;
    border-top: 2px solid #000;
    margin-left: -2px;
}
  .sin-pro-text-img-slide-main .must-have-images-wrap .slick-arrow:before {
	display: none;
}



/* Sin Pro Text Image */
  .sin-pro-img-cont-lr-main {
	position: relative;
	overflow: hidden;
    padding: 0 0 35px;
}
  .sin-pro-img-cont-lr-main .sin-pro-img-cont-lr-inn .slick-list {
    position: relative;
    overflow: visible;
}
  .sin-pro-img-cont-lr-main .sin-pro-img-cont-lr-inn .slick-arrow {
	display: none !important;
}
  .sin-pro-img-cont-lr-main .sin-pro-img-cont-lr-inn ul.slick-dots,
  .hm-fav-product-listing-main ul.slick-dots {
    margin: 0 auto;
}
  .sin-pro-img-cont-lr-main .sin-pro-img-cont-lr-inn ul.slick-dots li,
  .hm-fav-product-listing-main ul.slick-dots li {
    width: auto;
    height: auto;
    margin: 3px;
}
  .sin-pro-img-cont-lr-main .sin-pro-img-cont-lr-inn ul.slick-dots li button,
  .hm-fav-product-listing-main ul.slick-dots li button {
		font-size: 0;
		line-height: 0;
    border: 1px solid #00000033;
    border-radius: 50px;
    width: 13px;
    height: 13px;
    background: #fbfafa;
}
  .sin-pro-img-cont-lr-main .sin-pro-img-cont-lr-inn ul.slick-dots li button:before,
  .sin-pro-img-cont-lr-main .sin-pro-img-cont-lr-inn ul.slick-dots li button:after,
  .hm-fav-product-listing-main ul.slick-dots li button:before,
  .hm-fav-product-listing-main ul.slick-dots li button:after {
	display: none !important;
}
  .sin-pro-img-cont-lr-main .sin-pro-img-cont-lr-inn ul.slick-dots li.slick-active button,
  .hm-fav-product-listing-main ul.slick-dots li.slick-active button {
	background: #282828;
}
  .sin-pro-img-cont-lr-main .sin-pro-img-cont-lr-inn .slick-track,
  .hm-fav-product-listing-main .slick-track {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: nowrap;
      flex-wrap: nowrap;
}
  .sin-pro-img-cont-lr-main .sin-pro-img-cont-lr-inn .slick-track:before,
  .sin-pro-img-cont-lr-main .sin-pro-img-cont-lr-inn .slick-track:after,
  .hm-fav-product-listing-main .slick-track:before,
  .hm-fav-product-listing-main .slick-track:after {
	display: none;
}
  .sin-pro-img-cont-lr-main .sin-pro-img-cont-lr-row {
  padding: 4px;
  margin: 15px 0;
  border-radius: 8px;
  background: #FFF;
  -webkit-box-shadow: 0 1px 12px 1px rgba(133, 133, 133, 0.15);
          box-shadow: 0 1px 12px 1px rgba(133, 133, 133, 0.15);
  position: relative;
  overflow: hidden;
  height: auto;
  float: none;
  width: calc(100dvw - 40px);
}
  .sin-pro-img-cont-lr-main .sin-pro-img-cont-lr-row.slick-slide {
	margin-left: 9px;
	margin-right: 9px;
}
  .sin-pro-img-cont-lr-row .sin-pro-img-cont-lr-left {
  margin: 0;
}
  .sin-pro-img-cont-lr-img img {
  border-radius: 8px;
}
  .sin-pro-img-cont-lr-cont {
	padding: 22px 12px 26px !important;
}
  .sin-pro-img-cont-lr-cont h2 {
	color: #282828;
	font-family: Roboto;
	font-size: 32px;
	font-style: normal;
	font-weight: 400 !important;
	line-height: 118.75%;
  margin: 0 0 7px !important;
}
  .sin-pro-img-cont-lr-cont h4 {
	color: #AB3F22;
	font-family: Roboto;
	font-size: 16px;
	font-style: normal;
	font-weight: 400 !important;
	line-height: 118.75%;
	letter-spacing: 0.5px;
  margin: 0 0 6px !important;
}
  .sin-pro-img-cont-lr-cont, 
  .sin-pro-img-cont-lr-cont p {
	color: #282828;
	font-family: Roboto;
	font-size: 18px;
	font-style: normal;
	font-weight: 400;
	line-height: 150%;
  margin: 0 !important;
}



/**/
/* Happiness Guarantee */
.CP_AS_PDP_01 .gaurantee_banner-new .subheading-gaurantee {
    font-size: 25px;
    line-height: 68px;
    width: 85px;
    height: 85px;
    background-size: contain;
    background-repeat: no-repeat;
}


/**/
/* Curated / more sections */
  .gaurantee_banner.gaurantee_banner-new {
    padding: 0;
    margin: 0;
}
  .gaurantee_banner.gaurantee_banner-new .page-width {
  padding: 50px 25px;
}
  .gaurantee_banner.gaurantee_banner-new h2 {
    font-size: 32px;
    line-height: 118.75%;
    padding: 0;
    margin: 0 0 24px;
}
  .gaurantee_banner.gaurantee_banner-new p {
    color: #282828;
    text-align: center;
    font-family: Roboto;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    margin: 0 0 16px;
}
  .gaurantee_banner.gaurantee_banner-new p:last-of-type {
    margin-bottom: 0;
}
  .gaurantee_banner.gaurantee_banner-new .btn-more,
  .gaurantee_banner.gaurantee_banner-new .btn-more:hover {
    color: #FFF !important;
    background: #AB3F22 !important;
    background-color: #AB3F22 !important;
    padding: 13px 20px;
}
  .gaurantee_banner.gaurantee_banner-new .btn-more:hover {
    opacity: .8;
}



/**/
/* Curated For You (slider) */
  .ant-sole-cst-container {
  padding-left: 26px;
  padding-right: 26px;
}
  .hm-tp-fav-title-sec h3 {
	color: #282828;
	text-align: center;
	font-family: Roboto;
	font-size: 32px;
	font-style: normal;
	font-weight: 400;
	line-height: 118.75%;
}
  .hm-tp-fav-title-sec p { display:none; }
  .hm-fav-product-listing-main {
    margin: 0;
}
  .hm-fav-product-listing-main .slick-list {
    padding: 0 !important;
}
  li.custom-product-listing {
    width: 86vw;
    max-width: 338px;
    margin-left: 0;
    margin-right: 0;
}
  li.custom-product-listing .grid-view-item.product-card {
    margin: 0;
    position: relative;
}
  li.custom-product-listing .grid-view-item.product-card .grid-view-item__link {
    margin: 0;
    padding: 0;
}
  li.custom-product-listing .grid-view-item.product-card .grid-view-item__link .product_tag {
    color: #3D3D3D !important;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 121.429%;
    letter-spacing: 0.5px;
    text-transform: capitalize;
    margin: 24px 19px 0 0;
    padding: 3px 12px;
}
  li.custom-product-listing .sizeLabel {
    display: none !important;
}
  li.custom-product-listing .custom-add-to-cart-section {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
    min-width: 100%;
}
  .grid-view-item__image-wrapper {
    margin: 0 0 20px;
}
  .product-card .grid-view-item__image-wrapper .grid-view-item__image.pro-feature-image {
    display: block !important;
}
  .product-card .grid-view-item__image-wrapper img.pro-hover-image, 
  .product-card:hover .product-card__image-with-placeholder-wrapper .pro-hover-image {
    display: none !important;
}
  li.custom-product-listing .product-card .grid-view-item__title,
  li.custom-product-listing .product-card .price {
    display: block;
    color: #282828;
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 118.75%;
    letter-spacing: 0.5px;
    margin: 0 0 8px;
}
  li.custom-product-listing .product-card .price .price__regular .money {
    color: #282828;
    font-size: 14px;
    font-weight: 400;
    line-height: 150%;
}
  li.custom-product-listing .product-card .stamped-product-reviews-badge {
    display: none !important;
}
  li.custom-product-listing .product-card .price,
  li.custom-product-listing .product-card .product-colors-coll {
	margin-bottom: 16px;
}
  li.custom-product-listing .product-card .price__badges--listing { margin:0; }
  .product-colors-coll .swatch-color-count-text-total, 
  .product-colors-coll .swatch-color-count-text-total .total_number,
  .product-colors-coll .swatch-color-count-text-hover {
    color: #282828;
    font-family: Roboto;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: 0.5px;
}
  .product-colors-coll .swatch-color-count-text-hover {
    opacity: 1;
    margin-right: 2px;
    display: none;
}
  .product-colors-coll .swatch-color-count-text-total, 
  .product-colors-coll .swatch-color-count-text-total .total_number {
    font-weight: normal;
    line-height: 160%;
}
  li.custom-product-listing.slick-slide { opacity:0; }
  li.custom-product-listing.slick-current.slick-active { opacity:1; }
/**/
  li.custom-product-listing .size-tabs {
	margin: 0 0 9px;
  padding: 5px 0 0;
}
  li.custom-product-listing button.size-tab {
    color: #4C4C4C;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 1;
    letter-spacing: 0.5px;
    padding: 7px 6px;
    border-radius: 3px;
    border: 1px solid #C0C0C0;
    background: transparent;
    -webkit-appearance: none;
    margin: 0 2px 0 0;
}
  li.custom-product-listing button.size-tab.active {
    color: #FFF;
    background: #4C4C4C;
    border-color: #4C4C4C;
}
  li.custom-product-listing select.size-dropdown {
    color: #222421;
    text-align: center;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    letter-spacing: 0.5px;
    display: inline-block !important;
    padding: 4px 45px 4px 21px;
    margin: 0 0 0 10px;
    border: 1px solid #EEE;
    border-radius: 28px;
    position: relative;
    overflow: hidden;
}
  li.custom-product-listing button.custom-add-to-cart-btn {
    color: #FFF;
    text-align: center;
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%;
    letter-spacing: 1px;
    text-transform: uppercase;
    border-radius: 35px;
    background: #AB3F22;
    padding: 15px 25px 15px 25px;
    border: 0 none;
    width: 100%;
    max-width: 100%;
    margin: 8px 0 15px;
}
  .product-form__controls-group--submit .spurit-po-wrapper, 
  .product-form__controls-group--submit .design-pre-order-template-wrapper, 
  .product-form__controls-group--submit .design-pre-order-template-wrapper button#pre_order_custom,
  .spurit-po-wrapper .design-pre-order-template-wrapper:not(.false-style) [data-pre-order-atc-button="1"]:hover .pre-order-2-button.hover {
    width: 100%;
    min-width: 100%;
    height: 49px;
}


/* Insta Picture Section */
  .ant-bot-insta-sec-main .instabox a span {
    color: #282828;
    font-size: 14px;
    font-weight: 400;
    line-height: 150%;
}
  .ant-bot-insta-sec-main.insta-images-follow {
    padding: 28px 0;
}
  .product-page-insta.insta-images-follow p,
  .product-page-insta.insta-images-follow .hm-tp-fav-title-sec-link {
    display: block;
}
  .product-page-insta.insta-images-follow p {
    color: #282828;
    text-align: center;
    font-family: Roboto;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    letter-spacing: 0.5px;
    margin: 20px 0 20px;
}
  .product-page-insta.insta-images-follow .hm-tp-fav-title-sec-link a {
    color: #282828;
    text-align: center;
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 118.75%;
    letter-spacing: 0.5px;
    text-decoration: underline;
}
  .product-page-insta.insta-images-follow .hm-tp-fav-title-sec-link {
    margin: 0 0 14px;
}
  .ant-bot-insta-sec-main.insta-images-follow .slick-track {
    margin-bottom: -20px;
}
  .ant-bot-insta-sec-main.insta-images-follow .instaslider .instabox a:before {
    display: none;
}


/* FAQ Section */
  .sin-pro-faq-main {
    padding: 40px 25px;
    background: #F8F8F8;
}
  .sin-pro-faq-inn #product-accordion {
    margin: 0 0 10px;
}
/*   .sin-pro-faq-inn .ui-accordion .ui-accordion-header {
    color: #282828;
    font-family: Roboto;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    letter-spacing: 0.5px;
    padding: 20px 30px 20px 0px !important;
    border-top: 0 none !important;
    border-bottom: 1px solid #6F6F6F !important;
    margin: 0 !important;
} */
  .sin-pro-faq-inn .ui-accordion .ui-accordion-header {
    color: #282828;
    font-family: Roboto;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 118.75%;
    letter-spacing: 0.5px;
    padding: 18px 30px 18px 0px !important;
    border-top: 0 none !important;
    border-bottom: 1px solid #6F6F6F !important;
    margin: 0 !important;
}
  .sin-pro-faq-inn .ui-accordion .ui-accordion-header .ui-accordion-header-icon {
    inset: auto;
    top: 28px;
    right: 0;
    margin: 0 !important;
    padding: 0 !important;
}
  .sin-pro-faq-inn .ui-accordion .ui-accordion-content {
    color: #282828;
    font-size: 14px;
    line-height: 150%;
    padding: 10px 35px 20px 0px;
    background: transparent;
}
  .sin-pro-faq-inn .ui-accordion .ui-accordion-content a {
    color: inherit !important;
    text-decoration: underline;
}
  .sin-pro-faq-inn .ui-accordion .ui-accordion-content a:hover {
    color: inherit !important;
    text-decoration: none;
}
  .sin-pro-faq-main .sin-pro-faq-inn > h3 {
    color: #282828;
    text-align: center;
    font-family: Roboto;
    font-size: 32px;
    font-style: normal;
    font-weight: 500;
    line-height: 118.75%;
    text-transform: capitalize;
    margin: 0 0 15px;
    padding: 0;
}



/* Overall Reviews Section */
.sin-pro-review-sec#review-acord {
    padding: 38px 0 11px;
}
.sin-pro-review-sec#review-acord .title,
#review-acord #stamped-reviews-widget[data-widget-type=carousel] .stamped-carousel-title, 
#review-acord #stamped-reviews-widget[data-widget-type=carousel] .stamped-carousel-subtitle,
#stamped-reviews-widget[data-widget-type=carousel] .stamped-carousel-scroll .stamped-reviews-image,
#stamped-reviews-widget[data-widget-type=carousel] .stamped-carousel-scroll .stamped-reviews-location, 
#stamped-reviews-widget[data-widget-type=carousel] .stamped-carousel-scroll:before, 
#stamped-reviews-widget[data-widget-type=carousel] .stamped-carousel-scroll .stamped-reviews-author + span {
	display: none !important;
}
.sin-pro-review-sec#review-acord .sinpro-review-top-wrap {
    text-align: center;
}
.sin-pro-review-sec#review-acord .sinpro-review-allrattings-group {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
}
.sin-pro-review-sec#review-acord .sinpro-review-allrattings-num {
    color: #282828;
    text-align: center;
    font-family: "Open Sans";
    font-size: 32px;
    font-style: normal;
    font-weight: 600 !important;
    line-height: 1;
    letter-spacing: 0.5px;
    margin: 0 10px 0 0;
}
.sin-pro-review-sec#review-acord .sinpro-review-allrattings-stars i {
    vertical-align: middle;
    line-height: 1;
}
.sin-pro-review-sec#review-acord .sinpro-review-allrattings-stars i:before {
    font-size: 26px;
}
.sin-pro-review-sec#review-acord .stamped-carousel-subtitle-count {
    display: block;
    color: #282828;
    text-align: center;
    font-family: "Open Sans";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    letter-spacing: 0.5px;
    margin: 2px 0 0;
}
.sin-pro-review-sec#review-acord .stamped-carousel-subtitle-count:before {
    content: "Based on ";
}
.sin-pro-review-sec#review-acord .stamped-carousel-subtitle-count:after {
    content: " Reviews";
}
.sin-pro-review-sec#review-acord #stamped-reviews-widget[data-widget-type=carousel] .stamped-carousel-buttons {
    float: none;
    width: auto;
    font-size: 0;
    line-height: 0;
}
.sin-pro-review-sec#review-acord #stamped-reviews-widget[data-widget-type=carousel] .stamped-carousel-buttons div {
    width: 40px;
    height: 40px;
    border-radius: 100%;
    border: 1px solid #EDEDED;
    background: #EDEDED;
    z-index: 1;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    position: absolute;
    inset: auto;
    top: 50%;
    -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
            transform: translateY(-50%);
}
.sin-pro-review-sec#review-acord #stamped-reviews-widget[data-widget-type=carousel] .stamped-carousel-buttons div:after {
	content: "";
  display: block;
  width: 9px;
  height: 9px;
  -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
          transform: rotate(45deg);
  opacity: 0.7;
}
.sin-pro-review-sec#review-acord #stamped-reviews-widget[data-widget-type=carousel] .stamped-carousel-buttons .stamped-carousel-button-left { left:-26px; }
.sin-pro-review-sec#review-acord #stamped-reviews-widget[data-widget-type=carousel] .stamped-carousel-button-left:after {
    border-left: 2px solid #000;
    border-bottom: 2px solid #000;
    margin-right: -2px;
} 
.sin-pro-review-sec#review-acord #stamped-reviews-widget[data-widget-type=carousel] .stamped-carousel-buttons .stamped-carousel-button-right { right:-27px; }
.sin-pro-review-sec#review-acord #stamped-reviews-widget[data-widget-type=carousel] .stamped-carousel-button-right:after {
    border-right: 2px solid #000;
    border-top: 2px solid #000;
    margin-left: -2px;
}
.sin-pro-review-sec#review-acord #stamped-reviews-widget[data-widget-type=carousel] .stamped-carousel-buttons div:before {
	display: none;
}
.sin-pro-review-sec#review-acord .sin-pro-review-sec#review-acord .page-width,
.sin-pro-review-sec#review-acord #stamped-reviews-widget[data-widget-type=carousel] .stamped-carousel-scroll {
    position: relative;
    overflow: hidden;
    float: none;
}
.sin-pro-review-sec#review-acord #stamped-reviews-widget[data-widget-type=carousel] {
    width: 100%;
    max-width: calc(100% - 26px);
    margin-left: auto;
    margin-right: auto;
    overflow: visible;
}
.sin-pro-review-sec#review-acord #stamped-reviews-widget[data-widget-type=carousel] .stamped-carousel-scroll-wrapper {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
    -ms-flex-wrap: nowrap;
        flex-wrap: nowrap;
}
.sin-pro-review-sec#review-acord #stamped-reviews-widget[data-widget-type=carousel] .stamped-reviews-date {
    color: #282828;
    font-family: Roboto;
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
    margin: 4px 0 0;
    padding: 0;
    -webkit-box-ordinal-group: 3;
        -ms-flex-order: 2;
            order: 2;
    float: none;
}
.sin-pro-review-sec#review-acord #stamped-reviews-widget[data-widget-type=carousel] .stamped-ratings-wrapper {
    padding: 0;
    margin: 0;
    -webkit-box-ordinal-group: 2;
        -ms-flex-order: 1;
            order: 1;
}
.sin-pro-review-sec#review-acord #stamped-reviews-widget[data-widget-type=carousel] .stamped-carousel-scroll .stamped-reviews-message, 
.sin-pro-review-sec#review-acord #stamped-reviews-widget[data-widget-type=carousel] .stamped-carousel-scroll .stamped-reviews-author {
    margin-left: 0 !important;
}
.sin-pro-review-sec#review-acord #stamped-reviews-widget[data-widget-type=carousel] .stamped-carousel-scroll .stamped-reviews-rating, 
.sin-pro-review-sec#review-acord #stamped-reviews-widget[data-widget-type=carousel] .stamped-carousel-scroll .stamped-reviews-rating i {
    line-height: 0;
}
.sin-pro-review-sec#review-acord #stamped-reviews-widget[data-widget-type=carousel] .stamped-carousel-scroll .stamped-reviews-rating {
    margin: 0 0 9px;
}
.sin-pro-review-sec#review-acord #stamped-reviews-widget[data-widget-type=carousel] .stamped-carousel-scroll .stamped-reviews-rating i {
    width: 18px;
    height: 17px;
    background: #F4D95B;
    padding: 3px;
    margin-right: 4px;
    color: #ffffff !important;
    font-size: 12px;
    line-height: 1;
}
.sin-pro-review-sec#review-acord #stamped-reviews-widget[data-widget-type=carousel] .stamped-carousel-scroll .stamped-reviews-rating i:before {
    color: inherit;
    font-size: inherit;
    line-height: inherit;
    margin: 0;
}
.sin-pro-review-sec#review-acord #stamped-reviews-widget[data-widget-type=carousel] .stamped-carousel-scroll .stamped-reviews-title {
	color: #191C1F;
	font-family: Roboto;
	font-size: 15px;
	font-style: normal;
	font-weight: 600;
	line-height: 140%;
  margin: 0 !important;
}
.sin-pro-review-sec#review-acord #stamped-reviews-widget[data-widget-type=carousel] .stamped-carousel-scroll .stamped-reviews-title > a:not(:empty) {
	display: inline-block;
	vertical-align: top;
  margin: 0 0 8px !important;
}
.sin-pro-review-sec#review-acord #stamped-reviews-widget[data-widget-type=carousel] .stamped-carousel-scroll .stamped-reviews-message {
    padding: 0 !important;
    min-height: 70px;
}
.sin-pro-review-sec#review-acord #stamped-reviews-widget[data-widget-type=carousel] .stamped-carousel-scroll .stamped-reviews-message-block {
	color: #282828;
	font-family: Roboto;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 150%;
}
.sin-pro-review-sec#review-acord #stamped-reviews-widget[data-widget-type=carousel] .stamped-carousel-scroll .stamped-reviews-author {
    color: #282828;
    font-family: Roboto;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin: 8px 0 0 !important;
}
.sin-pro-review-sec#review-acord #stamped-reviews-widget[data-widget-type=carousel] .stamped-carousel-scroll .block {
    border-radius: 6px;
    background: #F8F8F8;
    padding: 15px 22px;
    margin: 8px 0;
    position: relative;
    overflow: hidden;
    min-width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    -webkit-box-pack: start;
        -ms-flex-pack: start;
            justify-content: flex-start;
    gap: 0;
    height: auto;
    min-height: auto;
}
.sin-pro-review-sec#review-acord .jdgm-seeallreviews-link,
.sin-pro-review-sec#review-acord .jdgm-seeallreviews-link a {
	color: #282828;
	font-family: "Open Sans";
	font-size: 16px;
	font-style: normal;
	font-weight: normal;
	line-height: 125%;
	letter-spacing: 0.5px;
	text-align: center;
}
.sin-pro-review-sec#review-acord .jdgm-seeallreviews-link { margin:15px 0 0; }
.sin-pro-review-sec#review-acord .jdgm-seeallreviews-link a { color:#282828!important;text-decoration:underline; }
.sin-pro-review-sec#review-acord .jdgm-seeallreviews-link a:hover { color:#282828!important;text-decoration:none; }


/**/
/* Size Guide popup tweaks */
  #shopify-section-size-guide .popup-overlay, 
  #shopify-section-size-guide-new .popup-overlay {
    padding: 45px 0;
}
  .size-guide__content .size-guide__main-title {
    color: #282828;
    font-size: 32px;
    font-weight: normal;
    line-height: 118.36%;
    margin: 0 0 20px;
    padding: 0 0 0;
}



 
}



/* CSS by Saurabh */
.cp_insta-slide {
    width: 85vw;
    max-width: calc(100vw - 120px);
    height: 363px;
}
.cp_insta-slide img {
    width: 100%;
    height: 100%;
    max-width: 100%;
    -o-object-fit: cover;
       object-fit: cover;
    border-radius: 15px;
}

.cp_insta-slide a:before {
    content: "";
    width: 100%;
    height: 146px;
    background: -webkit-gradient(linear, left top, left bottom, from(rgba(18, 18, 18, 0.80)), to(rgba(18, 18, 18, 0.00)));
    background: -o-linear-gradient(top, rgba(18, 18, 18, 0.80) 0%, rgba(18, 18, 18, 0.00) 100%);
    background: linear-gradient(180deg, rgba(18, 18, 18, 0.80) 0%, rgba(18, 18, 18, 0.00) 100%);
    position: absolute;
    inset: 0;
    bottom: auto;
}

.cp_insta-slide span {
    color: #322c2c;
    font-weight: 600;
    letter-spacing: 0;
    font-size: 15px;
    line-height: 150%;
    display: block;
    padding-top: 10px;
    display: none;
}

.cp_insta-slide {
    padding: 0 11px;
}

.cp_insta-slide a {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    display: block;
    border-radius: 12px;
    -webkit-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
    transition: all 0.5s ease-in-out;
    -webkit-transform: scale(1);
        -ms-transform: scale(1);
            transform: scale(1);
}

.cp_insta-slide.slick-active a {
    -webkit-transform: scale(1.1);
        -ms-transform: scale(1.1);
            transform: scale(1.1);
}
.cp_instaslider .slick-track {
    padding: 40px 0;
}
    `;

    // Clean out the CP_AS_PDP_01 scoping and keep show-fixed on body
    var cleanedCss = rawCss
      .replace(/body\.CP_AS_PDP_01\.show-fixed/g, 'body.show-fixed')
      .replace(/body\.CP_AS_PDP_01/g, '')
      .replace(/\.CP_AS_PDP_01/g, '');

    var style = document.createElement('style');
    style.id = 'custom-pdp-styles';
    style.textContent = cleanedCss;
    document.head.appendChild(style);
  })();

  /* ------------------------------------
     2) Helper: eleReady (as provided)
  ------------------------------------ */
  (function (win) {
    "use strict";
    var listeners = [],
      doc = win.document,
      MutationObserver = win.MutationObserver || win.WebKitMutationObserver,
      observer;

    function ready(selector, fn) {
      listeners.push({ selector, fn });
      if (!observer) {
        observer = new MutationObserver(check);
        observer.observe(doc.documentElement, {
          childList: true,
          subtree: true,
        });
      }
      check();
    }

    function check() {
      for (var i = 0; i < listeners.length; i++) {
        var listener = listeners[i];
        var elements = doc.querySelectorAll(listener.selector);
        for (var j = 0; j < elements.length; j++) {
          var element = elements[j];
          if (!element.__eleReadyHandled) {
            element.__eleReadyHandled = true;
            listener.fn.call(element, element);
          }
        }
      }
    }
    win.eleReady = ready;
  })(window);

  /* ------------------------------------
     3) Run main logic when PDP is ready
  ------------------------------------ */
  function run() {
    /* Header fixed helper */
    window.addEventListener('scroll', function () {
      const header = document.querySelector('.cst-header-sec-main');
      const body = document.body;
      if (!header) return;
      const scrollVal = header.scrollTop || 0;
      const windowScrollTop = window.scrollY || window.pageYOffset;
      if (windowScrollTop > scrollVal + 31) {
        body.classList.add('has-header-fixed');
      } else {
        body.classList.remove('has-header-fixed');
      }
    });

    /* Scroll Back behavior */
    let lastScrollTop = 0;
    window.addEventListener('scroll', () => {
      const currentScroll = window.scrollY || document.documentElement.scrollTop;
      const header = document.querySelector('#shopify-section-header');
      if (!header) return;
      const scrollingDown = currentScroll > lastScrollTop;
      const scrollingUp = currentScroll < lastScrollTop;
      if (currentScroll > 150 && scrollingUp) {
        header.classList.add('scrollback-fix');
      }
      if (scrollingDown || currentScroll <= 150) {
        header.classList.remove('scrollback-fix');
      }
      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    });

    /* Size Guide link text */
    const sizeGuideText = document.querySelector('.size-link-box > ul > li > a#size-guide-new');
    if (sizeGuideText) sizeGuideText.textContent = 'What’s My Size?';

    /* ---------------- Main & Thumb sliders rebuild ---------------- */
    let LAST_IMAGE_SRC = '';
    const waitForMainSlider = setInterval(() => {
      const mainSlider = document.querySelector('.mobile-main-pro-slide');
      if (!mainSlider || !mainSlider.classList.contains('slick-initialized')) return;

      clearInterval(waitForMainSlider);

      const imageElements = document.querySelectorAll(
        '.mobile-image-section .custom_image:not(.slick-cloned) .pro-item img.image'
      );
      if (!imageElements.length) return;

      let images = Array.from(imageElements)
        .map(img => img.getAttribute('data-mobile'))
        .filter(src => !!src);

      if (!images.length) return;

      LAST_IMAGE_SRC = images[images.length - 3] || images[images.length - 1];

      if (images.length >= 2) {
        const secondLast = images.splice(images.length - 2, 1)[0];
        images.unshift(secondLast);
      }

      if (window.jQuery && jQuery(mainSlider).hasClass('slick-initialized')) {
        jQuery(mainSlider).slick('unslick');
      }
      mainSlider.innerHTML = '';

      const oldThumbSlider = document.querySelector('.mobile-thumb-slide');
      if (oldThumbSlider) oldThumbSlider.remove();

      images.forEach(src => {
        const slide = document.createElement('div');
        const img = document.createElement('img');
        img.src = src;
        img.alt = 'Product Image';
        img.style.width = '100%';
        slide.appendChild(img);
        mainSlider.appendChild(slide);
      });

      const thumbSlider = document.createElement('div');
      thumbSlider.className = 'mobile-thumb-slide';
      mainSlider.parentNode.insertBefore(thumbSlider, mainSlider.nextSibling);

      images.forEach(src => {
        const thumb = document.createElement('div');
        const thumbImg = document.createElement('img');
        thumbImg.src = src;
        thumbImg.alt = 'Thumbnail';
        thumbImg.style.width = '100%';
        thumb.appendChild(thumbImg);
        thumbSlider.appendChild(thumb);
      });

      setTimeout(() => {
        initSlickWithRetry('.mobile-thumb-slide', {
          slidesToShow: 4,
          slidesToScroll: 1,
          focusOnSelect: true,
          arrows: false,
          dots: false,
          centerMode: false,
          variableWidth: true,
          centerPadding: '40px',
          asNavFor: '.mobile-main-pro-slide',
          infinite: true
        });

        initSlickWithRetry('.mobile-main-pro-slide', {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: true,
          fade: true,
          asNavFor: '.mobile-thumb-slide',
          infinite: true
        });

        if (typeof insertWhatAboutSection === 'function') {
          insertWhatAboutSection();
        }
      }, 500);
    }, 100);

    function initSlickWithRetry(selector, options, retries = 5) {
      const $el = window.jQuery && jQuery(selector);
      if (!$el || !$el.length) return;
      const tryInit = () => {
        if ($el.is(':visible')) {
          if (!$el.hasClass('slick-initialized')) {
            $el.slick(options);
          }
        } else if (retries > 0) {
          setTimeout(() => initSlickWithRetry(selector, options, retries - 1), 200);
        }
      };
      tryInit();
    }

    /* Price Label - Tax included */
    const priceLabel = document.querySelector('.product-single__meta > .price-title .price-item--regular');
    if (priceLabel) {
      const taxLabel = document.createElement('span');
      taxLabel.className = 'priceLabel';
      taxLabel.textContent = 'Tax included';
      priceLabel.parentNode.insertBefore(taxLabel, priceLabel.nextSibling);
    }

    /* Size Label in floating block */
    const stickySizeLabelWrap = document.querySelector('.custom-product-info .sizes_no');
    if (stickySizeLabelWrap) {
      const sizeLabel = document.createElement('span');
      sizeLabel.className = 'sizeLabel';
      sizeLabel.textContent = `Size`;
      stickySizeLabelWrap.parentNode.insertBefore(sizeLabel, stickySizeLabelWrap);
    }

    /* Gives back section */
    const newMainContent = document.querySelector('body.template-product main.main-content');
    const givesBackHtml = `
      <div class="pdp-givesback-section">
        <div class="wrap-container">
          <img src="//useruploads.vwo.io/useruploads/1116290/images/c6ea1f8e9c3a1e1c5ffc55d7750ab54b_givesbackimage.jpg" alt="Gives Back" width="680" height="383" />
          <h2>We are a business <br>that gives back.</h2>
          <h4>Feed a child with every purchase</h4>
          <ul>
            <li>
              <span class="icon">
                <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="https://www.w3.org/2000/svg"><mask id="mask0_171_2316" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="19"><path d="M18 9.23047C18 7.45044 17.4722 5.71038 16.4832 4.23034C15.4943 2.7503 14.0887 1.59674 12.4442 0.915557C10.7996 0.234369 8.99002 0.0561382 7.24419 0.403405C5.49836 0.750672 3.89471 1.60784 2.63604 2.86651C1.37737 4.12518 0.520203 5.72883 0.172936 7.47466C-0.174331 9.22049 0.00389993 11.0301 0.685088 12.6747C1.36627 14.3192 2.51983 15.7248 3.99987 16.7137C5.47991 17.7027 7.21997 18.2305 9 18.2305V9.23047H18Z" fill="white"></path></mask><g mask="url(#mask0_171_2316)"><path d="M18 9.23047C18 7.45044 17.4722 5.71038 16.4832 4.23034C15.4943 2.7503 14.0887 1.59674 12.4442 0.915557C10.7996 0.234369 8.99002 0.0561382 7.24419 0.403405C5.49836 0.750672 3.89471 1.60784 2.63604 2.86651C1.37737 4.12518 0.520203 5.72883 0.172936 7.47466C-0.174331 9.22049 0.00389993 11.0301 0.685088 12.6747C1.36627 14.3192 2.51983 15.7248 3.99987 16.7137C5.47991 17.7027 7.21997 18.2305 9 18.2305V9.23047H18Z" stroke="white" stroke-width="2"></path></g><path d="M11 17.2305C11.7879 17.2305 12.5681 17.0753 13.2961 16.7738C14.0241 16.4722 14.6855 16.0303 15.2426 15.4731C15.7998 14.916 16.2417 14.2546 16.5433 13.5266C16.8448 12.7986 17 12.0184 17 11.2305H11V17.2305Z" fill="#AB3F22"></path></svg>
              </span>
              <span class="text">Donation: 10% of profit</span>
            </li>
            <li>
              <span class="icon">
                <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="https://www.w3.org/2000/svg"><path d="M2.24 9.06936C1.84461 8.67659 1.53134 8.20905 1.31845 7.694C1.10556 7.17894 0.997308 6.62667 1 6.06936C1 4.94219 1.44777 3.86118 2.2448 3.06415C3.04183 2.26712 4.12283 1.81936 5.25 1.81936C6.83 1.81936 8.21 2.67936 8.94 3.95936H10.06C10.4311 3.30842 10.9681 2.76745 11.6163 2.39153C12.2645 2.01562 13.0007 1.81819 13.75 1.81936C14.8772 1.81936 15.9582 2.26712 16.7552 3.06415C17.5522 3.86118 18 4.94219 18 6.06936C18 7.23936 17.5 8.31936 16.76 9.06936L9.5 16.3193L2.24 9.06936ZM17.46 9.77936C18.41 8.81936 19 7.51936 19 6.06936C19 4.67697 18.4469 3.34161 17.4623 2.35705C16.4777 1.37248 15.1424 0.819354 13.75 0.819354C12 0.819354 10.45 1.66935 9.5 2.98936C9.0151 2.31586 8.37661 1.76767 7.63748 1.39028C6.89835 1.01289 6.0799 0.817172 5.25 0.819354C3.85761 0.819354 2.52226 1.37248 1.53769 2.35705C0.553123 3.34161 0 4.67697 0 6.06936C0 7.51936 0.59 8.81936 1.54 9.77936L9.5 17.7393L17.46 9.77936Z" fill="white"></path><path d="M10.0007 13.7151L9.39648 13.1651C7.25065 11.2193 5.83398 9.93184 5.83398 8.36101C5.83398 7.07351 6.84232 6.06934 8.12565 6.06934C8.85065 6.06934 9.54648 6.40684 10.0007 6.93601C10.4548 6.40684 11.1507 6.06934 11.8757 6.06934C13.159 6.06934 14.1673 7.07351 14.1673 8.36101C14.1673 9.93184 12.7507 11.2193 10.6048 13.1651L10.0007 13.7151Z" fill="#AB3F22"></path></svg>
              </span>
              <span class="text">Goal: Helping hungry children in marginalised communities.</span>
            </li>
          </ul>
          <div class="btn-group">
            <a class="btn-more" href="/pages/make-good-do-good" aria-describedby="a11y-external-message">Learn More</a>
          </div>
        </div>
      </div>`;
    if (newMainContent && !document.querySelector('.pdp-givesback-section')) {
      newMainContent.insertAdjacentHTML('beforeend', givesBackHtml);
    }

    /* Move Sin Pro Fea Section & add line */
    const sinProFeaContent = document.querySelector('.sin-pro-fea-pro-cont');
    const sinProFeaContentNewHtml = `<p><strong>Still Unsure?</strong> <span>Check Our Money Back Guarantee.</span></p>`;
    if (sinProFeaContent && !sinProFeaContent.querySelector('p span')) {
      sinProFeaContent.insertAdjacentHTML('beforeend', sinProFeaContentNewHtml);
    }
    const sinProFea = document.querySelector('.sin-pro-fea-pro-sec');
    const sinProFeaTarget = document.querySelector('.custom-product-info #shipp_accordion');
    if (sinProFea && sinProFeaTarget && sinProFeaTarget.parentNode) {
      sinProFeaTarget.parentNode.insertBefore(sinProFea, sinProFeaTarget);
    }

    /* What about these shoes section */
    function insertWhatAboutSection() {
      function getCleanLiText(selector, fallback = '') {
        const li = document.querySelector(selector);
        if (!li) return fallback;
        const cloned = li.cloneNode(true);
        cloned.querySelectorAll('svg, span').forEach(el => el.remove());
        return cloned.textContent.trim() || fallback;
      }
      const subtitle_whatAbout = getCleanLiText('.sin-pro-rt-info-fea-desc ul li:nth-child(1)', '100% Spanish Leather');
      const description_whatAbout = getCleanLiText('.sin-pro-rt-info-fea-desc ul li:nth-child(2)', 'Its breathable sports footbed that will gently disperse the impact of each step you make.');
      const sinProFeaTargetOne = document.querySelector('.custom-product-info #shipp_accordion');
      if (!subtitle_whatAbout || !description_whatAbout || !sinProFeaTargetOne || !LAST_IMAGE_SRC) return;

      const aboutTheseShoesHtml = `
        <div class="about-these-shoes-section">
          <div class="wrap-container">
            <img src="${LAST_IMAGE_SRC}" alt="What about these shoes" width="712" height="950" class="abouttheseshoes-img" />
            <hr class="abouttheseshoes-hr" />
            <div class="abouttheseshoes-headings">
              <h2>What are these shoes about?</h2>
              <h4>${subtitle_whatAbout}</h4>
            </div>
            <p>${description_whatAbout}</p>
          </div>
        </div>`;
      if (!document.querySelector('.about-these-shoes-section')) {
        sinProFeaTargetOne.insertAdjacentHTML('beforebegin', aboutTheseShoesHtml);
      }
    }

    /* Judge Me Section text */
    const jdgmTitle = document.querySelector('.jdgm-carousel-wrapper .jdgm-carousel-title');
    const jdgmReviewEl = document.querySelector('.jdgm-carousel-number-of-reviews[data-number-of-reviews]');
    if (jdgmTitle && jdgmReviewEl) {
      const jdgmReviewNum = jdgmReviewEl.getAttribute('data-number-of-reviews');
      jdgmTitle.insertAdjacentHTML('beforebegin', `<div class="jdgm-carousel-label">Over ${jdgmReviewNum} Customer Reviews</div>`);
    }

    /* Instagram Picture slider clone */
    const brandWrapper = document.querySelector('.brands-section')?.parentNode;
    const instaPicWrapper = document.querySelector('.ant-bot-insta-sec-main.product-page-insta');
    const instaPicSection = instaPicWrapper?.parentNode;

    if (instaPicSection && brandWrapper && brandWrapper.parentNode) {
      const instaElems = document.querySelectorAll(".ant-bot-insta-sec-main .instabox:not(.slick-cloned)");
      var slider = document.createElement("div");
      slider.className = "cp_instaslider";
      instaElems.forEach(function (elem) {
        var slide = document.createElement("div");
        slide.className = "cp_insta-slide";
        slide.innerHTML = elem.innerHTML;
        var imgs = slide.querySelectorAll("img");
        imgs.forEach(function (img) {
          var dataSrc = img.getAttribute("data-src");
          if (dataSrc) img.setAttribute("src", dataSrc);
        });
        slider.appendChild(slide);
      });
      var target = document.querySelector(".jdgm-carousel-wrapper");
      if (target && target.parentNode && !document.querySelector('.cp_instaslider')) {
        target.parentNode.insertBefore(slider, target.nextSibling);
        if (window.jQuery) {
          jQuery('.cp_instaslider').slick({
            dots: false,
            slidesToShow: 4,
            slidesToScroll: 4,
            centerMode: true,
            centerPadding: '20px',
            prevArrow: false,
            nextArrow: false,
            variableWidth: true,
            responsive: [
              {
                breakpoint: 750,
                settings: {
                  slidesToScroll: 1,
                  centerMode: true,
                  centerPadding: '15px',
                  slidesToShow: 1,
                  dots: false,
                  prevArrow: false,
                  nextArrow: false,
                  variableWidth: true
                }
              }
            ]
          });
          window.addEventListener("resize", function () {
            jQuery('.cp_instaslider').slick('refresh');
          });
        }
      }
    }

    /* Video Reviews */
    const videoReviews = document.querySelector('.cstm-testimonial.video-reviews')?.parentNode;
    const videoReviewHeading = document.querySelector('.cstm-testimonial.video-reviews .tab-heading');
    if (videoReviews && brandWrapper && brandWrapper.parentNode && videoReviewHeading) {
      videoReviewHeading.textContent = "Check Out Some Videos";
      brandWrapper.parentNode.insertBefore(videoReviews, brandWrapper.nextSibling);
    }
    const videoReviewsTextHtml = `
      <div class="videoreview-content">
        <div class="videoreview-stars">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.7468 4.96525C11.7468 4.80062 11.6196 4.69586 11.3652 4.65096L7.88558 4.13463L6.3366 0.991776C6.24681 0.812184 6.13456 0.722388 5.99987 0.722388C5.86517 0.722388 5.75293 0.812184 5.66313 0.991776L4.11415 4.13463L0.634562 4.65096C0.380141 4.69586 0.25293 4.80062 0.25293 4.96525C0.25293 5.07001 0.312794 5.18225 0.432522 5.30198L2.94681 7.74892L2.34068 11.2061C2.34068 11.2659 2.34068 11.3108 2.34068 11.3408C2.34068 11.4306 2.36313 11.5091 2.40803 11.5765C2.45293 11.6438 2.52776 11.6775 2.63252 11.6775C2.70735 11.6775 2.79715 11.6476 2.90191 11.5877L5.99987 9.97137L9.09783 11.5877C9.20259 11.6476 9.29239 11.6775 9.36722 11.6775C9.47198 11.6775 9.54681 11.6438 9.59171 11.5765C9.6366 11.5091 9.65905 11.4306 9.65905 11.3408C9.65905 11.2809 9.65905 11.236 9.65905 11.2061L9.05293 7.74892L11.5672 5.30198C11.6869 5.18225 11.7468 5.07001 11.7468 4.96525Z" fill="#FAD739"></path></svg>
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.7468 4.96525C11.7468 4.80062 11.6196 4.69586 11.3652 4.65096L7.88558 4.13463L6.3366 0.991776C6.24681 0.812184 6.13456 0.722388 5.99987 0.722388C5.86517 0.722388 5.75293 0.812184 5.66313 0.991776L4.11415 4.13463L0.634562 4.65096C0.380141 4.69586 0.25293 4.80062 0.25293 4.96525C0.25293 5.07001 0.312794 5.18225 0.432522 5.30198L2.94681 7.74892L2.34068 11.2061C2.34068 11.2659 2.34068 11.3108 2.34068 11.3408C2.34068 11.4306 2.36313 11.5091 2.40803 11.5765C2.45293 11.6438 2.52776 11.6775 2.63252 11.6775C2.70735 11.6775 2.79715 11.6476 2.90191 11.5877L5.99987 9.97137L9.09783 11.5877C9.20259 11.6476 9.29239 11.6775 9.36722 11.6775C9.47198 11.6775 9.54681 11.6438 9.59171 11.5765C9.6366 11.5091 9.65905 11.4306 9.65905 11.3408C9.65905 11.2809 9.65905 11.236 9.65905 11.2061L9.05293 7.74892L11.5672 5.30198C11.6869 5.18225 11.7468 5.07001 11.7468 4.96525Z" fill="#FAD739"></path></svg>
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.7468 4.96525C11.7468 4.80062 11.6196 4.69586 11.3652 4.65096L7.88558 4.13463L6.3366 0.991776C6.24681 0.812184 6.13456 0.722388 5.99987 0.722388C5.86517 0.722388 5.75293 0.812184 5.66313 0.991776L4.11415 4.13463L0.634562 4.65096C0.380141 4.69586 0.25293 4.80062 0.25293 4.96525C0.25293 5.07001 0.312794 5.18225 0.432522 5.30198L2.94681 7.74892L2.34068 11.2061C2.34068 11.2659 2.34068 11.3108 2.34068 11.3408C2.34068 11.4306 2.36313 11.5091 2.40803 11.5765C2.45293 11.6438 2.52776 11.6775 2.63252 11.6775C2.70735 11.6775 2.79715 11.6476 2.90191 11.5877L5.99987 9.97137L9.09783 11.5877C9.20259 11.6476 9.29239 11.6775 9.36722 11.6775C9.47198 11.6775 9.54681 11.6438 9.59171 11.5765C9.6366 11.5091 9.65905 11.4306 9.65905 11.3408C9.65905 11.2809 9.65905 11.236 9.65905 11.2061L9.05293 7.74892L11.5672 5.30198C11.6869 5.18225 11.7468 5.07001 11.7468 4.96525Z" fill="#FAD739"></path></svg>
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.7468 4.96525C11.7468 4.80062 11.6196 4.69586 11.3652 4.65096L7.88558 4.13463L6.3366 0.991776C6.24681 0.812184 6.13456 0.722388 5.99987 0.722388C5.86517 0.722388 5.75293 0.812184 5.66313 0.991776L4.11415 4.13463L0.634562 4.65096C0.380141 4.69586 0.25293 4.80062 0.25293 4.96525C0.25293 5.07001 0.312794 5.18225 0.432522 5.30198L2.94681 7.74892L2.34068 11.2061C2.34068 11.2659 2.34068 11.3108 2.34068 11.3408C2.34068 11.4306 2.36313 11.5091 2.40803 11.5765C2.45293 11.6438 2.52776 11.6775 2.63252 11.6775C2.70735 11.6775 2.79715 11.6476 2.90191 11.5877L5.99987 9.97137L9.09783 11.5877C9.20259 11.6476 9.29239 11.6775 9.36722 11.6775C9.47198 11.6775 9.54681 11.6438 9.59171 11.5765C9.6366 11.5091 9.65905 11.4306 9.65905 11.3408C9.65905 11.2809 9.65905 11.236 9.65905 11.2061L9.05293 7.74892L11.5672 5.30198C11.6869 5.18225 11.7468 5.07001 11.7468 4.96525Z" fill="#FAD739"></path></svg>
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.7468 4.96525C11.7468 4.80062 11.6196 4.69586 11.3652 4.65096L7.88558 4.13463L6.3366 0.991776C6.24681 0.812184 6.13456 0.722388 5.99987 0.722388C5.86517 0.722388 5.75293 0.812184 5.66313 0.991776L4.11415 4.13463L0.634562 4.65096C0.380141 4.69586 0.25293 4.80062 0.25293 4.96525C0.25293 5.07001 0.312794 5.18225 0.432522 5.30198L2.94681 7.74892L2.34068 11.2061C2.34068 11.2659 2.34068 11.3108 2.34068 11.3408C2.34068 11.4306 2.36313 11.5091 2.40803 11.5765C2.45293 11.6438 2.52776 11.6775 2.63252 11.6775C2.70735 11.6775 2.79715 11.6476 2.90191 11.5877L5.99987 9.97137L9.09783 11.5877C9.20259 11.6476 9.29239 11.6775 9.36722 11.6775C9.47198 11.6775 9.54681 11.6438 9.59171 11.5765C9.6366 11.5091 9.65905 11.4306 9.65905 11.3408C9.65905 11.2809 9.65905 11.236 9.65905 11.2061L9.05293 7.74892L11.5672 5.30198C11.6869 5.18225 11.7468 5.07001 11.7468 4.96525Z" fill="#FAD739"></path></svg>
        </div>
        <p class="videoreview-title">Awesome Purchase</p>
        <p class="videoreview-text">Super comfortable and go with almost every summer outfit</p>
      </div>`;
    eleReady('.vid-wrapper--slider .vid.item--cst', function (el) {
      if (!el.querySelector('.videoreview-content')) {
        el.insertAdjacentHTML('beforeend', videoReviewsTextHtml);
      }
    });

    /* Sin Pro Image/Content wrapper slider */
    eleReady('.sin-pro-img-cont-lr-main .sin-pro-img-cont-lr-inn', function (el) {
      setTimeout(function () {
        if (window.jQuery) {
          jQuery(el).slick({
            dots: true,
            infinite: true,
            arrows: false,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true
          });
        }
      }, 0);
    });

    /* 30 Day Happiness Guarantee reposition */
    const sinProImgCont = document.querySelector('.sin-pro-img-cont-lr-main');
    const happinessGuarantee = document.querySelector('.gaurantee_banner.gaurantee_banner-new');
    if (happinessGuarantee && sinProImgCont && sinProImgCont.parentNode) {
      sinProImgCont.parentNode.insertBefore(happinessGuarantee, sinProImgCont.nextSibling);
    }

    /* Curated For You slider tweaks */
    const curatedTitle = document.querySelector('.ant-sole-cst-container .hm-tp-fav-title-sec h3');
    if (curatedTitle) curatedTitle.textContent = 'Curated For You';

    eleReady('.hm-fav-product-listing-main', function (el) {
      const $slider = window.jQuery && jQuery(el);
      const slickOptions = {
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        infinite: false,
        variableWidth: true
      };
      function updateSlickOptions() {
        if ($slider && $slider.hasClass('slick-initialized') && typeof jQuery.fn.slick === 'function') {
          $slider.slick('slickSetOption', slickOptions, true);
        } else {
          setTimeout(updateSlickOptions, 200);
        }
      }
      updateSlickOptions();
    });

    /* Must Have Section slider */
    const mustHaveParentSec = document.querySelector('.sin-pro-text-img-slide-main');
    const container = document.querySelector('.sin-pro-text-img-slide-main .mobile-custom-grid-sect');
    const gridSection = container?.querySelector('.sin-pro-text-img-slide-main .mobile-custom-grid-sect-inn');
    if (container && gridSection && !gridSection.querySelector('.must-have-images-wrap')) {
      const imgElements = container.querySelectorAll('img');
      const imgArray = Array.from(imgElements);
      const slickWrapper = document.createElement('div');
      slickWrapper.className = 'must-have-images-wrap';
      imgArray.forEach(img => {
        const imgClone = img.cloneNode(true);
        const imgBox = document.createElement('div');
        imgBox.appendChild(imgClone);
        slickWrapper.appendChild(imgBox);
      });
      gridSection.appendChild(slickWrapper);
      eleReady('.must-have-images-wrap', function (el) {
        const $slider = window.jQuery && jQuery(el);
        if ($slider && typeof $slider.slick === 'function') {
          $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            infinite: true
          });
        }
      });
    }
    const headingText = document.querySelector('.sin-pro-text-img-slide-main .mobile-custom-grid-sect-cont p');
    if (headingText) {
      headingText.innerHTML = `Every modern woman has a pair of go-to shoe she knows she can rely on. <br>Experience blissful comfort. That pain you don’t feel after wearing shoes the whole day… yes, that’s what we are talking about. <br>It’s all made possible as each pair is made with unlined leather and has an ergonomic sports-engineered footbed.`;
    }
    if (happinessGuarantee && mustHaveParentSec) {
      happinessGuarantee.parentNode.insertBefore(mustHaveParentSec, happinessGuarantee.nextSibling);
    }

    /* Move More FAQ above reviews */
    const moreFaqSec = document.querySelector('.sin-pro-faq-main#more-faqs');
    const wholeReview = document.querySelector('.sin-pro-review-sec#review-acord');
    if (wholeReview && moreFaqSec && wholeReview.parentNode) {
      wholeReview.parentNode.insertBefore(moreFaqSec, wholeReview);
    }

    /* All Reviews header block */
    eleReady('#stamped-reviews-widget[data-widget-type="carousel"]', function (widgetEl) {
      const interval = setInterval(() => {
        const rating = widgetEl.getAttribute('data-rating-all');
        const starsWrapper = widgetEl.querySelector('.stamped-carousel-stars-wrapper');
        const reviewsCountEl = widgetEl.querySelector('.stamped-carousel-subtitle-count');
        const titleEl = document.querySelector('.sin-pro-review-sec#review-acord .title');
        if (rating && starsWrapper && reviewsCountEl && titleEl) {
          clearInterval(interval);
          const reviewTopWrap = document.createElement('div');
          reviewTopWrap.className = 'sinpro-review-top-wrap';
          const ratingsGroup = document.createElement('div');
          ratingsGroup.className = 'sinpro-review-allrattings-group';
          const ratingNum = document.createElement('span');
          ratingNum.className = 'sinpro-review-allrattings-num';
          ratingNum.textContent = rating;
          const ratingStars = document.createElement('span');
          ratingStars.className = 'sinpro-review-allrattings-stars';
          ratingStars.appendChild(starsWrapper.cloneNode(true));
          ratingsGroup.appendChild(ratingNum);
          ratingsGroup.appendChild(ratingStars);
          const reviewCount = reviewsCountEl.cloneNode(true);
          reviewTopWrap.appendChild(ratingsGroup);
          reviewTopWrap.appendChild(reviewCount);
          titleEl.insertAdjacentElement('afterend', reviewTopWrap);
        }
      }, 200);
    });

    const jdgmWrapReviewAll = document.querySelector('.sin-pro-review-sec#review-acord .page-width');
    if (jdgmWrapReviewAll && !jdgmWrapReviewAll.querySelector('.jdgm-seeallreviews-link')) {
      jdgmWrapReviewAll.insertAdjacentHTML('beforeend', `<div class="jdgm-seeallreviews-link"><a href="/pages/reviews">See all Reviews</a></div>`);
    }

    /* Money Back Guarantee accordion opener & show-fixed toggler */
    eleReady('.sin-pro-fea-pro-cont p:first-of-type > span', function () {
      const triggerSpan = document.querySelector('.sin-pro-fea-pro-cont p:first-of-type > span');
      const header = document.querySelector('.custom-product-info #shipp_accordion.ui-accordion .ui-accordion-header#ui-id-3');
      const content = document.querySelector('.custom-product-info #shipp_accordion.ui-accordion .ui-accordion-content#ui-id-4');
      if (!triggerSpan || !header || !content) return;

      triggerSpan.addEventListener('click', () => {
        header.classList.remove('ui-accordion-header-collapsed', 'ui-corner-all');
        header.classList.add('ui-accordion-header-active', 'ui-state-active');
        header.setAttribute('aria-selected', 'true');
        header.setAttribute('aria-expanded', 'true');
        content.classList.add('ui-accordion-content-active');
        if (window.jQuery) jQuery(content).slideDown(300);
        setTimeout(() => {
          const yOffset = -80;
          const y = header.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }, 350);
      });

      (function () {
        var toggleClass = "show-fixed";
        var target = document.querySelector(".sin-pro-fea-pro-sec");
        if (!target) return;
        window.addEventListener("scroll", function () {
          var targetTop = target.getBoundingClientRect().top + window.scrollY;
          var scrollTop = window.scrollY || document.documentElement.scrollTop;
          if (scrollTop >= targetTop) {
            document.body.classList.add(toggleClass);
          } else {
            document.body.classList.remove(toggleClass);
          }
        });
      })();
    });

    /* PDP curated add-to-cart micro UI on cards */
    eleReady('.custom-product-listing', function (listing) {
      const productLink = listing.querySelector('.grid-view-item__link');
      if (!productLink) return;
      const productUrl = productLink.getAttribute('href');
      if (!productUrl) return;

      fetch(productUrl + '.js')
        .then(res => res.json())
        .then(product => {
          if (listing.querySelector('.custom-add-to-cart-section')) return;

          const container = document.createElement('div');
          container.classList.add('custom-add-to-cart-section');

          const tabWrapper = document.createElement('div');
          tabWrapper.classList.add('size-tabs');
          tabWrapper.innerHTML = `
            <button class="size-tab active" data-type="EU">EU</button>
            <button class="size-tab" data-type="US">US</button>
          `;

          const sizeLabel = document.createElement('div');
          sizeLabel.classList.add('sizeLabel');
          sizeLabel.textContent = 'Select Size';

          const sizeDropdown = document.createElement('select');
          sizeDropdown.classList.add('size-dropdown');

          const addToCartBtn = document.createElement('button');
          addToCartBtn.classList.add('custom-add-to-cart-btn');
          addToCartBtn.textContent = 'Add to Bag';

          container.appendChild(tabWrapper);
          container.appendChild(sizeLabel);
          container.appendChild(sizeDropdown);
          container.appendChild(addToCartBtn);

          const target = listing.querySelector('.product-colors-coll');
          if (target) target.insertAdjacentElement('afterend', container);

          populateDropdown('EU');

          tabWrapper.querySelectorAll('.size-tab').forEach(tab => {
            tab.addEventListener('click', () => {
              tabWrapper.querySelectorAll('.size-tab').forEach(t => t.classList.remove('active'));
              tab.classList.add('active');
              populateDropdown(tab.getAttribute('data-type'));
            });
          });

          sizeDropdown.addEventListener('change', function () {
            const selectedOption = sizeDropdown.options[sizeDropdown.selectedIndex];
            sizeLabel.textContent = selectedOption ? selectedOption.textContent : 'Select Size';
          });

          function populateDropdown(type) {
            sizeDropdown.innerHTML = '';
            product.variants.forEach(variant => {
              let label = variant.title;
              if (type === 'US') label = convertToUS(variant.title);
              if (variant.available) {
                const option = document.createElement('option');
                option.value = variant.id;
                option.textContent = label;
                sizeDropdown.appendChild(option);
              }
            });
            if (sizeDropdown.options.length > 0) {
              sizeLabel.textContent = sizeDropdown.options[0].textContent;
            } else {
              sizeLabel.textContent = 'Out of Stock';
            }
          }

          function convertToUS(euSize) {
            const map = {
              'EU35': 'US4',
              'EU36': 'US5',
              'EU37': 'US6',
              'EU38': 'US7',
              'EU39': 'US8',
              'EU40': 'US9',
              'EU41': 'US9.5',
              'EU42': 'US10',
              'EU43': 'US11',
              'EU44': 'US12'
            };
            return map[euSize] || euSize;
          }

          addToCartBtn.addEventListener('click', function (e) {
            e.preventDefault();
            const variantId = sizeDropdown.value;
            if (!variantId) {
              alert('Please select a size.');
              return;
            }
            addToCartBtn.textContent = 'Adding...';
            addToCartBtn.disabled = true;

            if (!window.jQuery) { addToCartBtn.textContent='Add to Bag'; addToCartBtn.disabled=false; return; }

            jQuery.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: { id: variantId, quantity: 1 },
              dataType: 'json',
              success: function () {
                jQuery.ajax({
                  type: 'GET',
                  url: '/cart.js',
                  dataType: 'json',
                  success: function (cartdata) {
                    jQuery('.site-header__cart #CartCount').html(cartdata.item_count);
                    jQuery.ajax({
                      type: "GET",
                      url: "/cart",
                      dataType: 'html',
                      success: function (data) {
                        var countget = jQuery(data).find('.cart_count_items').html();
                        jQuery('.cart_count_items').html(countget);
                        var minicartdata = jQuery(data).filter('#slidingcartmain').html();
                        jQuery('#slidingcartmain').html(minicartdata);
                        jQuery("#overlay").addClass("is-active");
                        jQuery(".inline-cart").addClass("is-active");
                        addToCartBtn.textContent = 'Add to Bag';
                        addToCartBtn.disabled = false;
                      }
                    });
                  }
                });
              },
              error: function (resp) {
                alert(resp.responseJSON && resp.responseJSON.description || 'Unable to add to cart');
                addToCartBtn.textContent = 'Add to Bag';
                addToCartBtn.disabled = false;
              }
            });
          });
        });
    });

    /* Floating size list toggle on mobile bar */
    eleReady('.custom-product-info .product-form__for_floating', function () {
      const sizeBtns = document.querySelectorAll('.product-form__for_floating .product-form__for_floating-left .size-each-pro.size-each');
      const sizeLabel = document.querySelector('.custom-product-info .product-form__for_floating .sizeLabel');
      const sizesNo = document.querySelector('.custom-product-info .product-form__for_floating .sizes_no');

      if (sizeLabel && sizesNo) {
        sizeLabel.addEventListener('click', (e) => {
          e.stopPropagation();
          sizesNo.classList.add('show');
        });
      }

      if (sizeBtns && sizeLabel && sizesNo) {
        sizeBtns.forEach(btn => {
          btn.addEventListener('click', () => {
            const selectedSize = btn.innerText.trim();
            sizeLabel.innerText = selectedSize;
            sizesNo.classList.remove('show');
          });
        });
      }

      document.addEventListener('click', function (e) {
        if (!sizesNo || !sizeLabel) return;
        if (!sizesNo.contains(e.target) && !sizeLabel.contains(e.target)) {
          sizesNo.classList.remove('show');
        }
      });

      window.addEventListener('scroll', function () {
        if (sizesNo) sizesNo.classList.remove('show');
      });
    });

  } 
  function startWhenReady() {
    const targetSel = '.mobile-image-section .pro-item img.image';
    if (document.querySelector(targetSel)) {
      run();
      return;
    }
    const mo = new MutationObserver(() => {
      if (document.querySelector(targetSel)) {
        mo.disconnect();
        run();
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startWhenReady);
  } else {
    startWhenReady();
  }
})();

const targetText = "Check Our Money Back Guarantee.";
const elements = document.querySelectorAll("p, span, a, div");

elements.forEach(el => {
  if (el.textContent.trim() === targetText) {
    el.style.cursor = "pointer";
    el.addEventListener("click", () => {
      window.location.href = "https://sg.anothersole.com/pages/returns-exchange";
    });
  }
});

}